{
  "absences.actions.add": "+ Absence",
  "absences.delete.confirm": "Really delete this absence?",
  "absences.empty": "This organization has no current employments.",
  "absences.errors.loadFailed": "The absence calendar could not be loaded.",
  "absences.form.add": "Add",
  "absences.form.choosePerson": "Choose a person …",
  "absences.form.close": "Close",
  "absences.form.createTitle": "New absence",
  "absences.form.editTitle": "Edit absence",
  "absences.form.fields.dateFrom": "From",
  "absences.form.fields.dateTo": "To",
  "absences.form.fields.note": "Note",
  "absences.form.fields.person": "Person",
  "absences.form.fields.type": "Type",
  "absences.form.generated": "A rule set wrote this absence from what was stamped. It cannot be changed here — the next run would overwrite the change.",
  "absences.form.problems.isGenerated": "A rule set wrote this absence, so it cannot be changed by hand.",
  "absences.form.problems.overlaps": "This person already has an absence in this period.",
  "absences.form.problems.overlapsGenerated": "These days already carry an absence a rule set wrote from what was stamped.",
  "absences.form.problems.saveFailed": "The absence could not be saved.",
  "absences.form.saving": "Saving …",
  "absences.form.validation.dateFromRequired": "Please enter the first day.",
  "absences.form.validation.dateToRequired": "Please enter the last day.",
  "absences.form.validation.noteMaxLength": "The note can be at most 500 characters long.",
  "absences.form.validation.personRequired": "Please choose a person.",
  "absences.form.validation.rangeReversed": "“To” cannot be before “From”.",
  "absences.form.viewTitle": "Absence",
  "absences.generated": "written by the rule set from what was stamped",
  "absences.hint": "Click a day in a row to enter an absence there, click a bar to open it. Ctrl + mouse wheel zooms.",
  "absences.navigation.goTo": "Go to date",
  "absences.navigation.today": "Today",
  "access.permission.employment.admin": "Manage employment",
  "access.permission.employment.admin.description": "Edit and view employments, time tracking and time accounts of the readable units.",
  "access.permission.group.employment": "Employment",
  "access.permission.group.skill": "Skills",
  "access.permission.skill.admin": "Manage skills",
  "access.permission.skill.admin.description": "Create, change and delete the skill catalogue.",
  "auth.callback.backToSignIn": "Back to sign in",
  "auth.callback.errors.authFailed": "Authentication failed. Please try again.",
  "auth.callback.errors.exchangeFailed": "Exchange failed ({{status}}).",
  "auth.callback.errors.missingCode": "Missing authorization code.",
  "auth.callback.errors.serverNotConfirmed": "Server did not confirm authentication.",
  "auth.callback.errors.sessionAfterSignIn": "Session could not be established after sign-in.",
  "auth.callback.errors.sessionFailed": "Session could not be established. Please sign in again.",
  "auth.callback.exchanging": "Exchanging authorization code…",
  "auth.callback.subtitle": "Please wait while we finish connecting your account.",
  "auth.callback.success": "Success. Redirecting…",
  "auth.callback.title": "Completing sign-in",
  "auth.forgotPassword.errors.invalidToken": "This reset link is invalid or expired.",
  "auth.forgotPassword.errors.passwordRequirements": "Your new password does not meet the requirements.",
  "auth.forgotPassword.errors.requestFailed": "Could not send reset email. Please try again.",
  "auth.forgotPassword.errors.resetFailed": "The password could not be reset. Please try again.",
  "auth.forgotPassword.request.form.emailLabel": "Email",
  "auth.forgotPassword.request.form.emailPlaceholder": "you@company.com",
  "auth.forgotPassword.request.sending": "Sending…",
  "auth.forgotPassword.request.signInPrompt": "Remember your password?",
  "auth.forgotPassword.request.submit": "Send reset link",
  "auth.forgotPassword.request.subtitle": "We will email you a link to choose a new password.",
  "auth.forgotPassword.request.title": "Reset your password",
  "auth.forgotPassword.reset.form.confirmPasswordLabel": "Confirm password",
  "auth.forgotPassword.reset.form.confirmPasswordPlaceholder": "Confirm password",
  "auth.forgotPassword.reset.form.emailLabel": "Email",
  "auth.forgotPassword.reset.form.newPasswordLabel": "New password",
  "auth.forgotPassword.reset.form.newPasswordPlaceholder": "New password",
  "auth.forgotPassword.reset.signInPrompt": "Done?",
  "auth.forgotPassword.reset.submit": "Update password",
  "auth.forgotPassword.reset.submitting": "Updating…",
  "auth.forgotPassword.reset.subtitle": "Enter and confirm your new password.",
  "auth.forgotPassword.reset.title": "Choose a new password",
  "auth.forgotPassword.signInLink": "Sign in",
  "auth.forgotPassword.success.emailSent": "If an account exists, we sent a reset link to your email.",
  "auth.forgotPassword.success.passwordUpdated": "Password updated. Redirecting to sign in…",
  "auth.forgotPassword.validation.confirmPasswordRequired": "Please confirm your password",
  "auth.forgotPassword.validation.passwordMinLength": "Password must be at least 8 characters",
  "auth.forgotPassword.validation.passwordMismatch": "Passwords do not match",
  "auth.forgotPassword.validation.passwordRequired": "Password is required",
  "auth.login.credentials.invalid": "Invalid email or password.",
  "auth.login.credentials.unexpectedError": "Something went wrong. Please try again.",
  "auth.login.error.title": "Sign-in failed",
  "auth.login.errors.Callback": "There was a problem with the callback.",
  "auth.login.errors.CredentialsSignin": "Sign in failed. Check the details you provided are correct.",
  "auth.login.errors.default": "Authentication failed. Please try again.",
  "auth.login.errors.EmailCreateAccount": "Could not create account.",
  "auth.login.errors.emailNotVerified": "Verify your email before signing in. Check your inbox for the confirmation link.",
  "auth.login.errors.EmailSignin": "Check your email for the sign in link.",
  "auth.login.errors.invite_required": "You need an invitation to sign up. Ask an administrator of your organization to send you an invite link.",
  "auth.login.errors.inviteRequired": "You need an invitation to sign up. Ask an administrator of your organization to send you an invite link.",
  "auth.login.errors.OAuthAccountNotLinked": "Account not linked. Please sign in with the same account you used originally.",
  "auth.login.errors.OAuthCallback": "Sign-in with your provider failed. Please try again.",
  "auth.login.errors.OAuthCreateAccount": "Could not create account.",
  "auth.login.errors.OAuthSignin": "There was a problem signing you in via OAuth.",
  "auth.login.errors.pending_approval": "Your account was created but is not active yet. An administrator must approve your access before you can sign in.",
  "auth.login.errors.pendingApproval": "Your account was created but is not active yet. An administrator must approve your access before you can sign in.",
  "auth.login.errors.Signin": "There was a problem signing you in.",
  "auth.login.forgotPassword": "Forgot password?",
  "auth.login.form.emailLabel": "Email",
  "auth.login.form.emailPlaceholder": "you@company.com",
  "auth.login.form.passwordLabel": "Password",
  "auth.login.form.passwordPlaceholder": "••••••••",
  "auth.login.noMethodsConfigured": "No sign-in methods are configured.",
  "auth.login.oauth.continueWith": "Or continue with",
  "auth.login.oauth.custom": "Sign in",
  "auth.login.oauth.discord": "Discord",
  "auth.login.oauth.google": "Google",
  "auth.login.oauth.microsoft": "Microsoft",
  "auth.login.pageSubtitle": "Use your email or a connected account to continue.",
  "auth.login.pageTitle": "Sign in",
  "auth.login.pendingApproval.title": "Account pending activation",
  "auth.login.rateLimit.message": "Try again in {{seconds}} seconds.",
  "auth.login.rateLimit.title": "Too many attempts",
  "auth.login.rememberMe": "Remember me",
  "auth.login.signIn": "Sign in",
  "auth.login.signingIn": "Signing in…",
  "auth.login.signUp.link": "Create an account",
  "auth.login.signUp.prompt": "New here?",
  "auth.login.validation.passwordMinLength": "Password must be at least 6 characters",
  "auth.login.validation.passwordRequired": "Password is required",
  "auth.logout": "Logout",
  "auth.password.errors.notAvailable": "Password change is not available.",
  "auth.register.createAccount": "Create account",
  "auth.register.creatingAccount": "Creating account…",
  "auth.register.errors.emailAlreadyExists": "An account with this email already exists.",
  "auth.register.errors.failedGeneric": "Registration failed.",
  "auth.register.errors.failedRetry": "Registration failed. Please try again.",
  "auth.register.errors.fillRequired": "Please fill in all required fields.",
  "auth.register.errors.inviteRequired": "You need an invitation to sign up. Ask an administrator of your organization to send you an invite link.",
  "auth.register.errors.notAvailable": "Registration is not available.",
  "auth.register.form.emailLabel": "Email",
  "auth.register.form.emailPlaceholder": "you@company.com",
  "auth.register.form.nameLabel": "Full name",
  "auth.register.form.namePlaceholder": "Jane Doe",
  "auth.register.form.passwordLabel": "Password",
  "auth.register.form.passwordPlaceholder": "Create a strong password",
  "auth.register.passwordHint": "At least 8 characters with uppercase, lowercase, a number, and a symbol.",
  "auth.register.passwordUnavailable.lead": "Registration is not available.",
  "auth.register.passwordUnavailable.signInLink": "Sign in",
  "auth.register.signIn.link": "Sign in",
  "auth.register.signIn.prompt": "Already have an account?",
  "auth.register.subtitle": "Get started with Workforce in a few steps.",
  "auth.register.title": "Create your account",
  "auth.register.validation.nameMaxLength": "Name is too long",
  "auth.register.validation.nameRequired": "Name is required",
  "auth.register.validation.passwordMaxLength": "Password is too long",
  "auth.register.validation.passwordMinLength": "Password must be at least 8 characters",
  "auth.register.validation.passwordPattern": "Password does not meet complexity requirements",
  "auth.register.validation.passwordRequired": "Password is required",
  "auth.resendVerification.failed": "We could not send a new verification email. Please try again.",
  "auth.verifyEmail.failed": "We could not verify your email address. The link may have expired.",
  "common.actions.cancel": "Cancel",
  "common.actions.delete": "Delete",
  "common.actions.edit": "Edit",
  "common.actions.reset": "Reset",
  "common.actions.save": "Save",
  "common.form.optional": "optional",
  "common.form.validation.companyMaxLength": "Company must be 255 characters or less",
  "common.form.validation.emailInvalid": "Enter a valid email address",
  "common.form.validation.emailMaxLength": "Email is too long",
  "common.form.validation.emailRequired": "Email is required",
  "common.form.validation.firstNameMaxLength100": "First name must be 100 characters or less",
  "common.form.validation.firstNameRequired": "First name is required",
  "common.form.validation.lastNameMaxLength100": "Last name must be 100 characters or less",
  "common.form.validation.lastNameRequired": "Last name is required",
  "common.form.validation.maxLength1000": "Must be 1000 characters or less",
  "common.form.validation.nameMaxLength": "Name is too long",
  "common.form.validation.nameRequired": "Name is required",
  "common.form.validation.phoneMaxLength": "Phone must be 30 characters or less",
  "common.form.validation.titleMaxLength10": "Title must be 10 characters or less",
  "common.form.validation.typeRequired": "Type is required",
  "common.loading": "Loading…",
  "common.messages.confirm": "Are you sure?",
  "common.messages.deleteConfirm": "Are you sure you want to delete this item?",
  "common.messages.error": "An error occurred",
  "common.messages.success": "Operation completed successfully",
  "contacts.actions.create": "Create contact",
  "contacts.delete.description": "This action cannot be undone.",
  "contacts.details.contactInfo": "Contact Information",
  "contacts.details.fields.company": "Company",
  "contacts.details.fields.createdAt": "Created At",
  "contacts.details.fields.updatedAt": "Updated At",
  "contacts.details.professionalInfo": "Professional Information",
  "contacts.details.tags": "Tags",
  "contacts.errors.personAlreadyExists": "A contact with this email already exists.",
  "contacts.form.createTitle": "Create contact",
  "contacts.form.editTitle": "Edit contact",
  "contacts.form.fields.additionalEmail": "Additional Email",
  "contacts.form.fields.email": "Email",
  "contacts.form.fields.firstName": "First Name",
  "contacts.form.fields.lastName": "Last Name",
  "contacts.form.fields.phone": "Phone",
  "contacts.form.fields.tags": "Tags",
  "contacts.form.fields.title": "Title",
  "contacts.form.fields.type": "Type",
  "contacts.form.help.tags": "Select one or more tags to classify this contact.",
  "contacts.form.placeholders.additionalEmail": "Enter additional email (optional)",
  "contacts.form.placeholders.email": "Enter email address",
  "contacts.form.placeholders.firstName": "Enter first name",
  "contacts.form.placeholders.lastName": "Enter last name",
  "contacts.form.placeholders.phone": "Enter phone number",
  "contacts.form.placeholders.title": "Select title",
  "contacts.form.sections.contact": "Contact details",
  "contacts.form.sections.name": "Name",
  "contacts.tags.host": "Host",
  "contacts.types.contractor": "Contractor",
  "contacts.types.employee": "Employee",
  "contacts.types.guest": "Guest",
  "contacts.types.resident": "Resident",
  "contacts.types.visitor": "Visitor",
  "costCenter.actions.create": "Create cost center",
  "costCenter.actions.hide": "Hide here",
  "costCenter.actions.override": "Override here",
  "costCenter.actions.restore": "Remove local version (inherit again)",
  "costCenter.delete.confirm": "Do you really want to delete this cost center?",
  "costCenter.errors.loadFailed": "Cost centers could not be loaded.",
  "costCenter.form.createTitle": "New cost center",
  "costCenter.form.editTitle": "Edit cost center",
  "costCenter.form.fields.department": "Area (optional)",
  "costCenter.form.fields.isInactive": "Currently invalid",
  "costCenter.form.fields.name": "Name",
  "costCenter.form.fields.number": "Cost center number",
  "costCenter.form.fields.validFrom": "Valid from",
  "costCenter.form.fields.validTo": "Valid to",
  "costCenter.form.overrideTitle": "Override cost center",
  "costCenter.form.saving": "Saving …",
  "costCenter.form.validation.departmentMaxLength": "Area is too long.",
  "costCenter.form.validation.nameMaxLength": "Name is too long.",
  "costCenter.form.validation.nameRequired": "Name is required.",
  "costCenter.form.validation.numberMaxLength": "Cost center number is too long.",
  "costCenter.form.validation.numberRequired": "Cost center number is required.",
  "costCenter.form.validation.validFromRequired": "Valid from is required.",
  "costCenter.list.empty": "No cost centers yet.",
  "costCenter.list.inactive": "invalid",
  "costCenter.list.inheritedFrom": "inherited from {{unit}}",
  "costCenter.list.overridden": "overridden",
  "dashboard.noPerson.description": "Your account is not linked to a person in any organization yet, so there is nothing to show here. Ask an administrator to send you an invite link.",
  "dashboard.noPerson.title": "No organization assigned",
  "dashboard.persons.grid.description": "Browse and manage persons in the selected organization.",
  "dashboard.scaffold.dummyDescription": "Placeholder page",
  "dashboard.scaffold.gridPlaceholder": "ag-grid placeholder",
  "dashboard.time.accounts.balanceDummy": "Dummy data for monthly balance",
  "dashboard.time.accounts.chartPlaceholder": "ag-chart placeholder — {{count}} data points",
  "dashboard.time.accounts.chartPlaceholderSimple": "ag-chart placeholder",
  "dashboard.time.accounts.historyTitle": "Time account history",
  "dashboard.time.accounts.hoursDummy": "Dummy data for hours worked",
  "dashboard.time.accounts.rangeLabel": "Period",
  "dsl.editor.activate": "Activate",
  "dsl.editor.activating": "Activating…",
  "dsl.editor.active": "Active",
  "dsl.editor.compileError.MULTIPLE_PIPELINES": "The workspace has more than one rule configuration block. Keep exactly one and move all rules into it.",
  "dsl.editor.compileError.PIPELINE_MISSING": "The workspace has no rule configuration block, so nothing can run. Add one from the Structure category.",
  "dsl.editor.compileError.title": "Saved, but no executable rules",
  "dsl.editor.context.appliesTo": "Applies to the time models:",
  "dsl.editor.context.appliesToAll": "Applies to every time model of this unit.",
  "dsl.editor.context.appliesToAllHint": "Stage 1 names no time model. A rule set on the same unit that names one explicitly wins for that time model.",
  "dsl.editor.context.governsNobody": "This rule set applies to nobody.",
  "dsl.editor.context.governsNobodyHint": "Stage 1 is empty, so no contract follows this rule set. Add “applies to time model” and save — it starts out covering every time model.",
  "dsl.editor.context.shadows": "Replaces the rule set of the same code on {{unit}}.",
  "dsl.editor.draft": "Draft — not running yet",
  "dsl.editor.draftRunning": "Draft — version {{running}} is running",
  "dsl.editor.loadFailed": "The rule set could not be loaded.",
  "dsl.editor.masterDataIssue.CHANGED_ON_LOAD": "stored, but changed on loading – check the block and save again",
  "dsl.editor.masterDataIssue.FIELD_OF_OTHER_ENTITY": "the field does not belong to this entity",
  "dsl.editor.masterDataIssue.NO_PREVIOUS_DAY": "this field has no previous day",
  "dsl.editor.masterDataIssue.UNKNOWN_DAY": "unknown day",
  "dsl.editor.masterDataIssue.UNKNOWN_ENTITY": "unknown entity",
  "dsl.editor.masterDataIssue.UNKNOWN_FIELD": "unknown field",
  "dsl.editor.masterDataIssues": "This version reads master data that cannot be read as stored. It can be activated once this is corrected:",
  "dsl.editor.noVersionYet": "Not saved yet",
  "dsl.editor.referenceIssues": "This rule set refers to master data that no longer exists in this organization unit:",
  "dsl.editor.referenceKind.account": "Account",
  "dsl.editor.referenceKind.bookingType": "Booking type",
  "dsl.editor.referenceKind.timeType": "Time type",
  "dsl.editor.save": "Save rule set",
  "dsl.editor.saveConflict.allTimeModels": "The rule set “{{ruleSet}}” ({{ruleSetCode}}) of this organization unit already applies to every time model. Only one rule set per unit can — name a specific time model here and save again.",
  "dsl.editor.saveConflict.timeModel": "The time model {{workSchedule}} is already assigned to the rule set “{{ruleSet}}” ({{ruleSetCode}}) of this organization unit. A time model can belong to only one rule set per unit — remove it from the assignment here or there and save again.",
  "dsl.editor.saveConflict.title": "Not saved",
  "dsl.editor.saving": "Saving …",
  "dsl.editor.title": "Rule set",
  "dsl.editor.version": "Version {{version}}",
  "dsl.masterData.fields.entryDate": "Entry date",
  "dsl.masterData.fields.exitDate": "Exit date",
  "dsl.masterData.fields.sicknessReferenceDate": "Sick-leave year start",
  "dsl.masterData.fields.sicknessServiceDurationDays": "Sick leave: entitlement-relevant service (days)",
  "dsl.masterData.fields.sicknessServiceStartDate": "Sick leave: start of countable service",
  "dsl.masterData.fields.vacationReferenceDate": "Holiday year start",
  "dsl.masterData.fields.vacationServiceDurationDays": "Holiday: entitlement-relevant service (days)",
  "dsl.masterData.fields.vacationServiceStartDate": "Vacation: start of countable service",
  "dsl.masterData.fields.vacationWaitingPeriodMonths": "Waiting period before the first holiday entitlement (months)",
  "dsl.masterData.fields.vacationYearType": "Holiday year",
  "dsl.masterData.fields.weeklyTargetMinutes": "Weekly target from the time model (minutes)",
  "dsl.masterData.fields.workDaysPerWeek": "Work days per week",
  "dsl.ruleSets.actions.create": "New rule set",
  "dsl.ruleSets.create.title": "New rule set",
  "dsl.ruleSets.delete.confirm": "Delete this rule set and all its versions?",
  "dsl.ruleSets.empty": "This unit has no rule set of its own. It follows its nearest ancestor’s.",
  "dsl.ruleSets.fields.code": "Code",
  "dsl.ruleSets.fields.codeHint": "The key inheritance matches on. Upper case, no spaces — it cannot be changed later.",
  "dsl.ruleSets.fields.name": "Name",
  "dsl.ruleSets.loadFailed": "The rule sets could not be loaded.",
  "dsl.ruleSets.neverSaved": "not saved yet",
  "dsl.ruleSets.problems.codePattern": "The code may contain only A–Z, 0–9 and underscores.",
  "dsl.ruleSets.problems.codeRequired": "Please enter a code.",
  "dsl.ruleSets.problems.codeTaken": "This unit already has a rule set with that code.",
  "dsl.ruleSets.problems.nameRequired": "Please enter a name.",
  "dsl.ruleSets.validation.codePattern": "The code may contain only A–Z, 0–9 and underscores.",
  "dsl.status.edit": "Edit rule set",
  "dsl.status.lastChanged": "Last changed",
  "dsl.status.loadFailed": "The rule set status could not be loaded.",
  "dsl.status.noRuleSet": "No rule set defined for this organization unit yet.",
  "dsl.status.version": "Version {{version}}",
  "employment.entity.absence": "Absence",
  "employment.entity.group.time": "Time",
  "employment.entity.timeAccount": "Time account",
  "employmentPicker.allUnits": "All units",
  "employmentPicker.empty": "No contract found",
  "employmentPicker.loading": "Searching …",
  "employmentPicker.more": "More matches – please narrow the search",
  "employmentPicker.noUnit": "No unit found",
  "employmentPicker.personnelNumber": "PNo. {{number}}",
  "employmentPicker.placeholder": "Name, personnel or contract number",
  "employmentPicker.unitPlaceholder": "Search unit",
  "employments.create": "New contract",
  "employments.directory.actions": "Actions",
  "employments.directory.back": "Back to the list",
  "employments.directory.chooseCompany": "Choose company",
  "employments.directory.company": "Company",
  "employments.directory.empty": "This tenant has no employments yet.",
  "employments.directory.more": "Load more",
  "employments.directory.noCompany": "This tenant has no company an employment can be created on.",
  "employments.directory.personnelNumber": "Personnel no.",
  "employments.directory.search": "Search",
  "employments.directory.state": "Status",
  "employments.directory.subtitle": "Every employment of the tenant – by name, personnel or contract number.",
  "employments.empty": "This unit has no contracts yet.",
  "employments.errors.loadFailed": "The contracts could not be loaded.",
  "employments.fields.employmentNumber": "Number",
  "employments.fields.employmentRelationship": "Employee group",
  "employments.fields.employmentType": "Contract type",
  "employments.fields.entryDate": "Entry",
  "employments.fields.exitDate": "Exit",
  "employments.fields.payGrade": "Pay grade",
  "employments.fields.payGradeLevel": "Pay grade level",
  "employments.fields.payScale": "Pay scale",
  "employments.fields.person": "Person",
  "employments.fields.sicknessCreditedFrom": "Sick leave: service counts from",
  "employments.fields.sicknessCreditedMonths": "Sick leave: credited months",
  "employments.fields.sicknessReferenceDate": "Sick-leave year starts",
  "employments.fields.vacationCreditedFrom": "Holiday: service counts from",
  "employments.fields.vacationCreditedMonths": "Holiday: credited months",
  "employments.fields.vacationReferenceDate": "Holiday year starts",
  "employments.fields.validFrom": "Valid from",
  "employments.fields.validTo": "Valid to",
  "employments.fields.weeklyHours": "Weekly hours",
  "employments.fields.workSchedule": "Time model",
  "employments.form.choose": "Please choose…",
  "employments.form.choosePerson": "Please choose a person…",
  "employments.form.chooseWorkSchedule": "Please choose a time model…",
  "employments.form.createTitle": "New contract",
  "employments.form.creditedHint": "Give prior service per purpose either as a date or as months, not both. Empty means nothing is credited.",
  "employments.form.editTitle": "Edit contract",
  "employments.form.none": "— none —",
  "employments.form.noWorkSchedules": "This organization unit has no time models yet. Create one under Time management → Time models.",
  "employments.form.personFixed": "Person and organization unit cannot be changed on an existing contract.",
  "employments.form.problems.employmentNumber": "Please enter a contract number.",
  "employments.form.problems.employmentType": "Please choose a contract type.",
  "employments.form.problems.entryDate": "Please enter an entry date.",
  "employments.form.problems.exitDateBeforeEntry": "The exit date is before the entry date.",
  "employments.form.problems.notAnEmployer": "Contracts belong to a company. This organization unit is not one — choose a company in the list.",
  "employments.form.problems.organizationUnitId": "No organization unit was passed. Please start from the list.",
  "employments.form.problems.personId": "Please choose a person.",
  "employments.form.problems.saveFailed": "Saving failed. Please try again.",
  "employments.form.problems.validFrom": "Please enter a start of validity.",
  "employments.form.problems.validToBeforeValidFrom": "Validity ends before it starts.",
  "employments.form.problems.weeklyHours": "Weekly hours must be a number, for example 38.5.",
  "employments.form.problems.workScheduleId": "Please choose a time model. Without it nothing plans this person’s days.",
  "employments.list.noMatch": "No contract matches the search.",
  "employments.list.search": "Search by number or name",
  "employments.onlyOnCompany": "Contracts are created on a company. Choose one above.",
  "employments.organizationUnit": "Organization unit",
  "employments.person.account": "Time account",
  "employments.person.none": "This person has no employment you may see.",
  "employments.person.open": "Open",
  "employments.person.tracking": "Time tracking",
  "employments.state.ACTIVE": "active",
  "employments.state.ENDED": "ended",
  "employments.state.UPCOMING": "upcoming",
  "nav.chart.month.apr": "Apr",
  "nav.chart.month.aug": "Aug",
  "nav.chart.month.dec": "Dec",
  "nav.chart.month.feb": "Feb",
  "nav.chart.month.jan": "Jan",
  "nav.chart.month.jul": "Jul",
  "nav.chart.month.jun": "Jun",
  "nav.chart.month.mar": "Mar",
  "nav.chart.month.may": "May",
  "nav.chart.month.nov": "Nov",
  "nav.chart.month.oct": "Oct",
  "nav.chart.month.sep": "Sep",
  "nav.chart.range.month": "Hours this month",
  "nav.chart.range.week": "Hours this week",
  "nav.chart.range.year": "Hours this year",
  "nav.chart.week.kw1": "Wk 1",
  "nav.chart.week.kw2": "Wk 2",
  "nav.chart.week.kw3": "Wk 3",
  "nav.chart.week.kw4": "Wk 4",
  "nav.chart.weekday.fri": "Fri",
  "nav.chart.weekday.mon": "Mon",
  "nav.chart.weekday.sat": "Sat",
  "nav.chart.weekday.sun": "Sun",
  "nav.chart.weekday.thu": "Thu",
  "nav.chart.weekday.tue": "Tue",
  "nav.chart.weekday.wed": "Wed",
  "nav.dashboard.title": "Dashboard",
  "nav.mobile.close": "Close",
  "nav.mobile.closeMenu": "Close menu",
  "nav.mobile.mainNavigation": "Main navigation",
  "nav.mobile.menu": "Menu",
  "nav.mobile.more": "More",
  "nav.mobile.moreSubtitle": "Additional sections",
  "nav.primary.home": "Home",
  "nav.primary.orgChart": "Org chart",
  "nav.primary.payScale": "Pay Scale",
  "nav.primary.payScale.short": "Pay scale",
  "nav.primary.persons": "Persons",
  "nav.primary.plan": "Plan",
  "nav.primary.settings": "Settings",
  "nav.primary.time": "Time",
  "nav.secondary.payScale.grades": "Pay grades",
  "nav.secondary.payScale.levels": "Pay grade levels",
  "nav.secondary.payScale.scales": "Pay scales",
  "nav.secondary.persons.employments": "Employments",
  "nav.secondary.persons.grid": "Person list",
  "nav.secondary.persons.profile": "Profile",
  "nav.secondary.persons.settings": "Settings",
  "nav.secondary.persons.skills": "Skills",
  "nav.secondary.plan.overview": "Overview",
  "nav.secondary.plan.schedule": "Shift schedule",
  "nav.secondary.settings.accounts": "Users",
  "nav.secondary.settings.general": "Settings",
  "nav.secondary.settings.organizations": "Organizations",
  "nav.secondary.settings.profile": "Profile",
  "nav.secondary.settings.roles": "Roles",
  "nav.secondary.settings.textCatalog": "Text catalog",
  "nav.secondary.time.absences": "Absences",
  "nav.secondary.time.accounts": "Time accounts",
  "nav.secondary.time.runs": "Start processing",
  "nav.secondary.time.runsLog": "Run log",
  "nav.secondary.time.tracking": "Time tracking",
  "nav.topbar.apps": "Apps",
  "nav.topbar.brand": "Workforce",
  "nav.topbar.home": "Workforce home",
  "nav.topbar.language": "Language",
  "nav.topbar.openMenu": "Open menu",
  "organigram.delete.confirm": "Delete",
  "organigram.delete.messageAssignment": "Do you really want to remove this person from the position?",
  "organigram.delete.messageOe": "Do you really want to delete this organizational unit? This cannot be undone.",
  "organigram.delete.messagePosition": "Do you really want to delete this position? This cannot be undone.",
  "organigram.delete.messageStation": "Do you really want to delete this station? This cannot be undone.",
  "organigram.delete.title": "Confirm deletion",
  "organigram.empty": "No organizational structure available.",
  "organigram.errors.childrenNotAllowed": "The units below this one could not sit under the new kind. Move them first, then change the kind.",
  "organigram.errors.companyEmploys": "Contracts hang on this unit, so it has to stay a company.",
  "organigram.errors.deleteFailed": "Deletion failed.",
  "organigram.errors.loadFailed": "The organigram could not be loaded.",
  "organigram.errors.moveFailed": "Move failed.",
  "organigram.errors.parentTakesNoChildren": "This unit holds no units of its own.",
  "organigram.errors.positionsNotAllowed": "Stellen hang on this unit, and the new kind carries none.",
  "organigram.errors.rootTakesOne": "The organization already has its company. Further units go beneath it.",
  "organigram.errors.saveFailed": "Saving failed.",
  "organigram.errors.stationsNotAllowed": "Stations hang on this unit, and the new kind carries none.",
  "organigram.errors.typeNotAllowedUnderParent": "This kind of unit cannot sit there. The order is: root → company → profit centre → department.",
  "organigram.node.add": "Add",
  "organigram.node.addOe": "Organizational unit",
  "organigram.node.addOeTooltip": "Add organizational unit",
  "organigram.node.addPerson": "Assign person",
  "organigram.node.addPosition": "Position",
  "organigram.node.addStation": "Station",
  "organigram.node.deleteOe": "Delete organizational unit",
  "organigram.node.deletePosition": "Delete position",
  "organigram.node.deleteStation": "Delete station",
  "organigram.node.editPosition": "Edit position",
  "organigram.node.editStation": "Edit station",
  "organigram.node.locked": "Locked (legal entity)",
  "organigram.node.settings": "Configuration",
  "organigram.node.viewPermissions": "View permissions",
  "organigram.oe.positionOne": "position",
  "organigram.oe.positionOther": "positions",
  "organigram.oe.stationOne": "station",
  "organigram.oe.stationOther": "stations",
  "organigram.oeType.company": "Company",
  "organigram.oeType.department": "Department",
  "organigram.oeType.organization": "Organization (root)",
  "organigram.oeType.profitCenter": "Profit centre",
  "organigram.panel.actions.cancel": "Cancel",
  "organigram.panel.actions.delete": "Delete",
  "organigram.panel.actions.save": "Save",
  "organigram.panel.actions.saving": "Saving …",
  "organigram.panel.errors.loadingPermissions": "Could not load permissions",
  "organigram.panel.fields.countryCode": "Country",
  "organigram.panel.fields.countryCodeNone": "No country",
  "organigram.panel.fields.description": "Description (optional)",
  "organigram.panel.fields.legalName": "Legal name (optional)",
  "organigram.panel.fields.name": "Name",
  "organigram.panel.fields.person": "Person",
  "organigram.panel.fields.personPlaceholder": "Please select …",
  "organigram.panel.fields.primary": "As primary position",
  "organigram.panel.fields.responsiblePerson": "Responsible",
  "organigram.panel.fields.responsiblePersonChosen": "Chosen:",
  "organigram.panel.fields.responsiblePersonClear": "remove",
  "organigram.panel.fields.responsiblePersonNone": "Nobody found.",
  "organigram.panel.fields.responsiblePersonSearch": "Search for a person …",
  "organigram.panel.fields.roles": "Roles",
  "organigram.panel.fields.timezone": "Time zone",
  "organigram.panel.fields.timezoneHint": "Decides what a rule means by a wall-clock time such as “not before 08:30”.",
  "organigram.panel.fields.timezoneInherited": "Same as the parent unit",
  "organigram.panel.fields.type": "Type",
  "organigram.panel.fields.vacationInherited": "— from the unit above —",
  "organigram.panel.fields.vacationWaitingPeriodHint": "Leave empty to take the value from the unit above. 0 means entitled from the first day.",
  "organigram.panel.fields.vacationWaitingPeriodMonths": "Waiting period before the first entitlement (months)",
  "organigram.panel.fields.vacationYearType": "Holiday year",
  "organigram.panel.noPersons": "No persons found in this organization.",
  "organigram.panel.noRoles": "No roles available.",
  "organigram.panel.permissions.all": "All",
  "organigram.panel.removeRole": "Remove role",
  "organigram.panel.rolePlaceholder": "Add role …",
  "organigram.panel.settings.accounts": "Accounts",
  "organigram.panel.settings.backToSections": "Back to the overview",
  "organigram.panel.settings.bookingTypes": "Booking types",
  "organigram.panel.settings.costCenters": "Cost centers",
  "organigram.panel.settings.dayPrograms": "Day programs",
  "organigram.panel.settings.employments": "Contracts",
  "organigram.panel.settings.groups.costAccounting": "Cost accounting",
  "organigram.panel.settings.groups.employment": "Contracts",
  "organigram.panel.settings.groups.hints.costAccounting": "Cost centres time is booked to",
  "organigram.panel.settings.groups.hints.employment": "Who is employed by this company",
  "organigram.panel.settings.groups.hints.timeManagement": "Booking types, time types, accounts and rules",
  "organigram.panel.settings.groups.hints.unit": "Name, type, time zone and core time",
  "organigram.panel.settings.groups.timeManagement": "Time management",
  "organigram.panel.settings.hints.accounts": "Balances such as flexitime and overtime",
  "organigram.panel.settings.hints.bookingTypes": "The reasons a stamp can be recorded",
  "organigram.panel.settings.hints.costCenters": "Which cost centres time is booked to",
  "organigram.panel.settings.hints.dayPrograms": "The planned shape of a working day",
  "organigram.panel.settings.hints.employments": "The contracts of this company’s employees",
  "organigram.panel.settings.hints.publicHolidays": "Which holidays apply, and whether whole or half",
  "organigram.panel.settings.hints.rules": "The rules that turn stamps into balances",
  "organigram.panel.settings.hints.timeTypes": "How recorded time is valued",
  "organigram.panel.settings.hints.workSchedules": "Which day program each weekday follows",
  "organigram.panel.settings.inherited": "This department inherits its configuration. It is maintained on the company or the organization above it.",
  "organigram.panel.settings.publicHolidays": "Public holidays",
  "organigram.panel.settings.root": "Configuration",
  "organigram.panel.settings.rules": "Rule set",
  "organigram.panel.settings.timeTypes": "Time types",
  "organigram.panel.settings.workSchedules": "Time models",
  "organigram.panel.title.assignPerson": "Assign person",
  "organigram.panel.title.createOe": "Add organizational unit",
  "organigram.panel.title.createPosition": "Add position",
  "organigram.panel.title.createStation": "Add station",
  "organigram.panel.title.editOe": "Edit organizational unit",
  "organigram.panel.title.editPosition": "Edit position",
  "organigram.panel.title.editStation": "Edit station",
  "organigram.panel.title.settings": "Configuration",
  "organigram.panel.title.viewPermissions": "Position permissions",
  "organigram.panel.vacationYear.calendarYear": "Calendar year",
  "organigram.panel.vacationYear.workYear": "Working year",
  "organigram.panel.validation.descriptionMaxLength": "Description is too long.",
  "organigram.panel.validation.legalNameMaxLength": "Legal name is too long.",
  "organigram.panel.validation.nameMaxLength": "Name is too long.",
  "organigram.panel.validation.nameRequired": "Name is required.",
  "organigram.panel.validation.vacationWaitingPeriodRange": "Enter a whole number from 0 to 120, or leave empty to inherit.",
  "organigram.position.empty": "No assignment",
  "organigram.position.label": "Position",
  "organigram.position.more": "More actions",
  "organigram.position.personOne": "person",
  "organigram.position.personOther": "persons",
  "organigram.position.roleOne": "role",
  "organigram.position.roleOther": "roles",
  "organigram.row.openPerson": "Open person",
  "organigram.row.primary": "Primary position",
  "organigram.row.removeAssignment": "Remove assignment",
  "organigram.row.secondary": "Assignment",
  "organigram.title": "Organigram",
  "organigram.toolbar.all": "All",
  "organigram.toolbar.arrange": "Arrange",
  "organigram.toolbar.arrangeHint": "Lay the chart out again as it was when loaded",
  "organigram.toolbar.collapseAll": "Collapse everything",
  "organigram.toolbar.collapsePositions": "Hide the positions of every unit",
  "organigram.toolbar.expandAll": "Expand positions, persons and stations",
  "organigram.toolbar.expandPositions": "Show the positions of every unit",
  "organigram.toolbar.positions": "Positions",
  "organigram.zoom.fit": "Fit organigram to view",
  "organigram.zoom.in": "Zoom in",
  "organigram.zoom.out": "Zoom out",
  "organigram.zoom.reset": "Reset zoom to 100%",
  "organization.entity.group.people": "People",
  "organization.entity.group.structure": "Structure",
  "organization.entity.organigram": "Organigram",
  "organization.entity.organizationUnit": "Organization Unit",
  "organization.entity.person": "Person",
  "organization.entity.personPosition": "Person Position",
  "organization.entity.position": "Position",
  "organization.persons.actions.addAndInvite": "Add person & send invite",
  "organization.persons.actions.creating": "Creating…",
  "organization.persons.actions.resendInvite": "Resend invite",
  "organization.persons.confirmRemove": "Remove {{name}} from this organization?",
  "organization.persons.empty": "No persons in this organization yet.",
  "organization.persons.errors.createFailed": "Could not create the person.",
  "organization.persons.errors.removeFailed": "Could not remove the person.",
  "organization.persons.errors.resendFailed": "Could not resend the invitation.",
  "organization.persons.fields.email": "Email",
  "organization.persons.fields.firstName": "First name",
  "organization.persons.fields.isOwner": "As admin / owner of the organization",
  "organization.persons.fields.lastName": "Last name",
  "organization.persons.inviteLink": "Link",
  "organization.persons.inviteSent": "Invitation sent to {{email}}.",
  "organization.persons.loading": "Loading persons…",
  "organization.persons.status.invited": " · invited",
  "organization.persons.status.linked": " · linked",
  "organization.persons.title": "Persons",
  "payScale.grades.actions.create": "Create pay grade",
  "payScale.grades.actions.edit": "Edit",
  "payScale.grades.actions.saving": "Saving…",
  "payScale.grades.columns.code": "Code",
  "payScale.grades.columns.employmentRelationship": "Employee group",
  "payScale.grades.columns.name": "Name",
  "payScale.grades.columns.payScale": "Pay scale",
  "payScale.grades.columns.validFrom": "Valid from",
  "payScale.grades.description": "Manage the salary groups of your collective agreements.",
  "payScale.grades.details.code": "Code",
  "payScale.grades.details.employmentRelationship": "Employee group",
  "payScale.grades.details.loading": "Loading pay grade…",
  "payScale.grades.details.name": "Name",
  "payScale.grades.details.payScale": "Pay scale",
  "payScale.grades.details.sections.info": "Pay grade information",
  "payScale.grades.details.validFrom": "Valid from",
  "payScale.grades.details.validTo": "Valid to",
  "payScale.grades.form.createTitle": "Create pay grade",
  "payScale.grades.form.editTitle": "Edit pay grade",
  "payScale.grades.form.fields.code": "Code",
  "payScale.grades.form.fields.employmentRelationship": "Employee group",
  "payScale.grades.form.fields.name": "Name",
  "payScale.grades.form.fields.payScale": "Pay scale",
  "payScale.grades.form.fields.validFrom": "Valid from",
  "payScale.grades.form.fields.validTo": "Valid to",
  "payScale.grades.form.loading": "Loading pay grade…",
  "payScale.grades.form.validation.codeMaxLength": "Code is too long",
  "payScale.grades.form.validation.codeRequired": "Code is required",
  "payScale.grades.form.validation.employmentRelationshipRequired": "Employee group is required",
  "payScale.grades.form.validation.nameMaxLength": "Name is too long",
  "payScale.grades.form.validation.nameRequired": "Name is required",
  "payScale.grades.form.validation.payScaleRequired": "Pay scale is required",
  "payScale.grades.form.validation.validFromRequired": "Valid from is required",
  "payScale.grades.list.placeholderDescription": "Select a pay grade from the table to view details in the drawer.",
  "payScale.grades.list.placeholderTitle": "Pay grades",
  "payScale.grades.title": "Pay grades",
  "payScale.levels.actions.create": "Create level",
  "payScale.levels.actions.edit": "Edit",
  "payScale.levels.actions.saving": "Saving…",
  "payScale.levels.advanceInfoMonths": "advances after {{months}}m",
  "payScale.levels.advanceInfoYears": "advances after {{years}}y",
  "payScale.levels.columns.amount": "Amount",
  "payScale.levels.columns.levelName": "Level",
  "payScale.levels.columns.payGrade": "Pay grade",
  "payScale.levels.columns.validFrom": "Valid from",
  "payScale.levels.description": "Manage the salary levels within each pay grade.",
  "payScale.levels.details.advance": "Advancement",
  "payScale.levels.details.amount": "Amount",
  "payScale.levels.details.levelName": "Level",
  "payScale.levels.details.loading": "Loading level…",
  "payScale.levels.details.nextGrade": "Next grade",
  "payScale.levels.details.nextLevel": "Next level",
  "payScale.levels.details.payGrade": "Pay grade",
  "payScale.levels.details.sections.info": "Level information",
  "payScale.levels.details.validFrom": "Valid from",
  "payScale.levels.details.validTo": "Valid to",
  "payScale.levels.form.createTitle": "Create level",
  "payScale.levels.form.editTitle": "Edit level",
  "payScale.levels.form.fields.advanceAfterMonths": "Advance after months",
  "payScale.levels.form.fields.advanceAfterYears": "Advance after years",
  "payScale.levels.form.fields.amount": "Amount",
  "payScale.levels.form.fields.levelName": "Level",
  "payScale.levels.form.fields.nextGrade": "Next grade",
  "payScale.levels.form.fields.nextLevel": "Next level",
  "payScale.levels.form.fields.none": "—",
  "payScale.levels.form.fields.payGrade": "Pay grade",
  "payScale.levels.form.fields.payScale": "Pay scale",
  "payScale.levels.form.fields.validFrom": "Valid from",
  "payScale.levels.form.fields.validTo": "Valid to",
  "payScale.levels.form.loading": "Loading level…",
  "payScale.levels.form.validation.amountRequired": "Amount is required",
  "payScale.levels.form.validation.levelNameRequired": "Level is required",
  "payScale.levels.form.validation.payGradeRequired": "Pay grade is required",
  "payScale.levels.form.validation.validFromRequired": "Valid from is required",
  "payScale.levels.list.placeholderDescription": "Select a level from the table to view details in the drawer.",
  "payScale.levels.list.placeholderTitle": "Pay grade levels",
  "payScale.levels.title": "Pay grade levels",
  "permission.action.create": "Create",
  "permission.action.delete": "Delete",
  "permission.action.read": "Read",
  "permission.action.readInternal": "See internal accounts",
  "permission.action.sendInvite": "Can send invite",
  "permission.action.update": "Update",
  "permission.matrix.action": "Action",
  "permission.matrix.entity": "Entity / Action",
  "permission.scope.all": "All",
  "permission.scope.child_oe": "Child OE",
  "permission.scope.own": "Own",
  "permission.scope.same_oe": "Same OE",
  "permission.scope.same_position": "Same Position",
  "persons.form.placeholders.city": "Enter city",
  "persons.form.placeholders.country": "Enter country",
  "persons.form.placeholders.personnelNumber": "Enter personnel number",
  "persons.form.placeholders.postalCode": "Enter postal code",
  "persons.form.placeholders.privateMobile": "Enter private mobile number",
  "persons.form.placeholders.socialSecurityNumber": "Enter social security number",
  "persons.form.placeholders.street": "Enter street",
  "persons.form.placeholders.vacationDays": "Enter vacation days",
  "persons.form.validation.cityMaxLength": "City must be 100 characters or less",
  "persons.form.validation.countryMaxLength": "Country must be 100 characters or less",
  "persons.form.validation.personnelNumberMaxLength": "Personnel number must be 50 characters or less",
  "persons.form.validation.postalCodeMaxLength": "Postal code must be 20 characters or less",
  "persons.form.validation.socialSecurityNumberMaxLength": "Social security number must be 50 characters or less",
  "persons.form.validation.streetMaxLength": "Street must be 255 characters or less",
  "persons.list.actions.create": "Create person",
  "persons.list.actions.deletePerson": "Delete person",
  "persons.list.actions.edit": "Edit",
  "persons.list.actions.saving": "Saving…",
  "persons.list.actions.sendInvite": "Send invite",
  "persons.list.allTypes": "All types",
  "persons.list.columns.email": "Email",
  "persons.list.columns.name": "Name",
  "persons.list.columns.personnelNumber": "Personnel no.",
  "persons.list.columns.type": "Type",
  "persons.list.description": "Browse and manage persons in the selected organization.",
  "persons.list.details.loading": "Loading person…",
  "persons.list.details.sections.account": "Account",
  "persons.list.details.sections.address": "Address",
  "persons.list.details.sections.administration": "Administration",
  "persons.list.details.sections.email": "Email",
  "persons.list.details.sections.meta": "Metadata",
  "persons.list.details.sections.socialSecurityReports": "Social security notifications",
  "persons.list.details.sections.socialSecurityReportsEmpty": "No social security notifications available.",
  "persons.list.fields.accountStatus": "Account status",
  "persons.list.fields.city": "City",
  "persons.list.fields.country": "Country",
  "persons.list.fields.mobile": "Mobile",
  "persons.list.fields.personnelNumber": "Personnel number",
  "persons.list.fields.postalCode": "Postal code",
  "persons.list.fields.privateEmail": "Email (private)",
  "persons.list.fields.privateMobile": "Private mobile",
  "persons.list.fields.socialSecurityNumber": "Social security number",
  "persons.list.fields.street": "Street",
  "persons.list.fields.vacationDays": "Vacation days",
  "persons.list.form.createTitle": "Create person",
  "persons.list.form.editTitle": "Edit person",
  "persons.list.form.loading": "Loading person…",
  "persons.list.form.placeholders.city": "Enter city",
  "persons.list.form.placeholders.country": "Enter country",
  "persons.list.form.placeholders.employmentRelationship": "Enter employee group",
  "persons.list.form.placeholders.employmentScopePercent": "e.g. 100",
  "persons.list.form.placeholders.personnelNumber": "Enter personnel number",
  "persons.list.form.placeholders.postalCode": "Enter postal code",
  "persons.list.form.placeholders.privateMobile": "Enter private mobile number",
  "persons.list.form.placeholders.socialSecurityNumber": "Enter social security number",
  "persons.list.form.placeholders.street": "Enter street",
  "persons.list.form.placeholders.vacationDays": "Enter vacation days",
  "persons.list.invite.sent": "Invitation sent to {{email}}.",
  "persons.list.noOrganization.description": "Select an organization in the context switcher to view persons.",
  "persons.list.noOrganization.title": "No organization selected",
  "persons.list.placeholderDescription": "Select a person from the table to view details in the drawer.",
  "persons.list.placeholderTitle": "Persons",
  "persons.list.search": "Search",
  "persons.list.searchPlaceholder": "Name, part of it or personnel number",
  "persons.list.status.invited": "Invited (pending)",
  "persons.list.status.linked": "Linked to user account",
  "persons.list.tabs.details": "Details",
  "persons.list.tabs.employments": "Employments",
  "persons.list.tabs.settings": "Settings",
  "persons.list.tabs.skills": "Skills",
  "persons.list.unlink.action": "Unlink account",
  "persons.list.unlink.confirmDescription": "This person will no longer be linked to the user account. The user account itself will not be deleted.",
  "persons.list.unlink.confirmTitle": "Unlink user account?",
  "persons.list.unlink.loading": "Unlinking…",
  "persons.list.unlink.success": "Person unlinked from user account.",
  "persons.profile.assignments.empty.description": "You are linked to this organization but not assigned to a position yet. An administrator needs to place you in the organigram to grant access.",
  "persons.profile.assignments.empty.title": "Not yet placed in the organigram",
  "persons.profile.assignments.noRoles": "No roles",
  "persons.profile.assignments.primary": "Primary",
  "persons.profile.assignments.rolesLabel": "Roles",
  "persons.profile.fields.account": "Account",
  "persons.profile.fields.company": "Company",
  "persons.profile.fields.createdAt": "Created at",
  "persons.profile.fields.email": "Email",
  "persons.profile.fields.personId": "Person ID",
  "persons.profile.fields.phone": "Phone",
  "persons.profile.fields.type": "Type",
  "persons.profile.loading": "Loading profile…",
  "persons.profile.noOrganization.description": "Select an organization in the context switcher to view your profile.",
  "persons.profile.noOrganization.title": "No organization selected",
  "persons.profile.noPerson.description": "No person is linked to your user account in this organization.",
  "persons.profile.noPerson.title": "No person in this organization",
  "persons.profile.sections.assignments": "Positions & roles",
  "persons.profile.sections.contact": "Contact",
  "persons.profile.sections.meta": "Metadata",
  "persons.profile.title": "Profile",
  "processing.closing.alreadyClosed": "This period is already closed.",
  "processing.closing.blockedByContracts": "Cannot close: {{count}} of {{seen}} contracts have an error. The rest is saved.",
  "processing.closing.close": "Close {{period}}",
  "processing.closing.gap.DEPENDENT": "skipped because an earlier day failed",
  "processing.closing.gap.FAILED": "processing failed",
  "processing.closing.gap.INPUT_CHANGED": "stamps changed after processing",
  "processing.closing.gap.NEVER_COMPUTED": "never processed",
  "processing.closing.gap.NO_RULE_SET": "no rule set assigned",
  "processing.closing.gap.NO_WORK_SCHEDULE": "no time model",
  "processing.closing.gap.RUN_FAILED": "the run failed as a whole",
  "processing.closing.hint": "A closing locks the period and records the balances. Reopening deletes nothing: the closing is marked as reversed and stays visible.",
  "processing.closing.incomplete": "Not completely processed: {{count}} gap(s) – the period stays open.",
  "processing.closing.moreGaps": "… and {{count}} more",
  "processing.closing.needsCompletedRun": "A closing needs a run that completed.",
  "processing.closing.reopen": "Reopen",
  "processing.closing.snapshots": "{{count}} balances recorded",
  "processing.closing.title": "Closing",
  "processing.log.covers": "{{days}} days · {{contracts}} contracts",
  "processing.log.days.date": "Date",
  "processing.log.days.employment": "Contract",
  "processing.log.days.entries": "Entries",
  "processing.log.days.none": "This run was responsible for no day at all.",
  "processing.log.days.reason": "Explanation",
  "processing.log.days.segments": "Segments",
  "processing.log.days.status": "Status",
  "processing.log.days.statuses.FAILED": "Failed",
  "processing.log.days.statuses.SKIPPED": "Skipped",
  "processing.log.days.statuses.SUCCEEDED": "Succeeded",
  "processing.log.days.title": "Days and contracts",
  "processing.log.days.warnings": "Warnings",
  "processing.log.newRun": "New run",
  "processing.log.run": "Run",
  "processing.log.subtitle": "Run status down to the person and the day, instead of one undifferentiated total failure.",
  "processing.log.totals.dependent": "Days waiting on a fix",
  "processing.log.totals.failed": "Days with an error",
  "processing.log.totals.skipped": "Days skipped",
  "processing.log.totals.succeeded": "Days that went through",
  "processing.messages.ABSENCE_ALREADY_BOOKED": "Absence was already booked",
  "processing.messages.ABSENCE_ENTERED_BY_HAND": "Absence entered by hand",
  "processing.messages.ABSENCE_NO_TIME_TYPE": "Absence without a time type",
  "processing.messages.ABSENCE_SPAN_WITHDRAWN": "Absence span withdrawn",
  "processing.messages.ABSENCE_UNKNOWN_TIME_TYPE": "Absence with an unknown time type",
  "processing.messages.ABSENCE_VALUED": "Absence valued",
  "processing.messages.ABSENCE_WITHOUT_SEGMENT": "Absence without a segment",
  "processing.messages.ACCOUNT_ALREADY_AT_VALUE": "The account already stands at this value",
  "processing.messages.AMBIGUOUS_SEGMENT_START": "Ambiguous segment start",
  "processing.messages.BOOKING_NO_ACCOUNT": "Booking without an account",
  "processing.messages.BOOKING_NO_AMOUNT": "Booking without an amount",
  "processing.messages.BOOKING_NO_VALUATION": "Booking without a valuation",
  "processing.messages.BREAK_RULE_NO_THRESHOLD": "Break rule without a threshold",
  "processing.messages.BREAK_SHORTFALL_DEDUCTED": "Missing break deducted",
  "processing.messages.BREAK_SHORTFALL_UNCOVERED": "Missing break not covered",
  "processing.messages.CATCH_UP_DAYS_ADDED": "Earlier days were caught up",
  "processing.messages.CATCH_UP_LIMIT_REACHED": "Catch-up limit reached; the rest stays open",
  "processing.messages.CLOSURE_AFTER_FAILED_DAY": "The closure phase did not run — the period has a hole in it",
  "processing.messages.CLOSURE_DAY_LOCKED": "Day locked by a closing",
  "processing.messages.CONDITION_NOT_EVALUABLE": "Condition could not be evaluated",
  "processing.messages.CORRECTION_NO_SEGMENT": "Correction found no segment",
  "processing.messages.CORRECTION_NO_TIME": "Correction without a valid time",
  "processing.messages.CORRECTION_NOT_IMPLEMENTED": "Correction not implemented",
  "processing.messages.DAILY_DURATION_LIMIT_REACHED": "Daily maximum reached",
  "processing.messages.DAILY_LIMIT_NOT_READABLE": "Daily maximum not readable",
  "processing.messages.DAY_FAILED": "The day failed",
  "processing.messages.DAY_LOCKED": "Day locked",
  "processing.messages.DAY_PLAN_MISSING": "No day program",
  "processing.messages.DEPENDENT_DAY_SKIPPED": "Skipped — an earlier day of this contract failed",
  "processing.messages.DEPENDENT_DAYS_ADDED": "Dependent later days were recomputed",
  "processing.messages.EARLIER_ENTRIES_REVERSED": "Entries from an earlier run reversed",
  "processing.messages.EARLIEST_START_APPLIED": "Earliest start applied",
  "processing.messages.EMPLOYMENT_FAILED": "Employment failed",
  "processing.messages.NO_SEGMENTATION_RULES": "No segmentation rules",
  "processing.messages.OPEN_SEGMENT_AFTER_CORRECTIONS": "Open segment after the corrections",
  "processing.messages.OVERLAPPING_SEGMENT_START": "Overlapping segment start",
  "processing.messages.RULE_MESSAGE": "Message from the rule set",
  "processing.messages.RULE_SET_INHERITED": "Rule set inherited from a parent unit",
  "processing.messages.RULE_SET_NOT_COMPILED": "Rule set not compiled",
  "processing.messages.SECTION_RULE_NO_ACCOUNT": "Section rule without an account",
  "processing.messages.SECTION_RULE_WRONG_PHASE": "Section rule in the wrong phase",
  "processing.messages.SEGMENT_CREATED": "Segment created by the rule set",
  "processing.messages.SEGMENT_NO_END": "Segment without an end",
  "processing.messages.SEGMENT_NO_START": "Segment without a start",
  "processing.messages.SEGMENT_NO_TIME_TYPE": "Segment without a time type",
  "processing.messages.SEGMENT_NOT_CLOSED": "Segment not closed",
  "processing.messages.SEGMENT_NOT_FORWARD": "Segment does not run forward",
  "processing.messages.SEGMENT_UNKNOWN_TIME_TYPE": "Segment with an unknown time type",
  "processing.messages.STATEMENT_NOT_IMPLEMENTED": "Statement not implemented yet",
  "processing.messages.TIMEZONE_FALLBACK": "Fallback time zone used",
  "processing.messages.TRANSFER_INCOMPLETE": "Transfer incomplete",
  "processing.messages.UNKNOWN_ACCOUNT": "Unknown account",
  "processing.messages.UNKNOWN_TIME_TYPE": "Unknown time type",
  "processing.messages.UNUSED_BOOKING": "Booking not used",
  "processing.messages.VARIABLE_NOT_RESOLVED": "Variable not resolved",
  "processing.overview.covers": "Over this unit and everything below it — {{count}} units. A run covers only the one you pick.",
  "processing.overview.errors.loadFailed": "The figures could not be loaded.",
  "processing.overview.lastProcessed": "Last processed",
  "processing.overview.lastProcessedHint": "the most recent run that finished",
  "processing.overview.never": "never yet",
  "processing.overview.openDays": "Open days",
  "processing.overview.openDaysHint": "up to yesterday, reached by no clean run yet",
  "processing.overview.retroactive": "Retroactive corrections",
  "processing.overview.retroactiveHint": "days already computed whose stamp arrived later",
  "processing.overview.withErrors": "Contracts with an error",
  "processing.overview.withErrorsHint": "in their most recent run",
  "processing.result.bookings": "Bookings",
  "processing.result.contract.figures": "{{from}} – {{to}}: {{succeeded}} days computed, {{failed}} with errors, {{skipped}} skipped, {{entries}} entries",
  "processing.result.contract.statuses.FAILED": "failed",
  "processing.result.contract.statuses.PARTIAL": "partly succeeded",
  "processing.result.contract.statuses.SKIPPED": "skipped",
  "processing.result.contract.statuses.SUCCEEDED": "succeeded",
  "processing.result.dayTotal": "Day total",
  "processing.result.employment": "Employment",
  "processing.result.empty": "This run produced no segments, bookings or messages.",
  "processing.result.errorCount": "{{count}} errors",
  "processing.result.errors.loadFailed": "The result could not be loaded.",
  "processing.result.governance.inheritedFrom": "· inherited from {{unit}}",
  "processing.result.governance.skipped.NO_RULE_SET": "No rule set for this time model — nothing computed",
  "processing.result.governance.skipped.NO_WORK_SCHEDULE": "No time model set — nothing computed",
  "processing.result.governance.skippedCount": "{{count}} contracts without a rule set",
  "processing.result.governance.title": "Rule sets applied",
  "processing.result.governance.version": "Version {{version}}",
  "processing.result.governance.workSchedule": "Time model",
  "processing.result.messageGroups.perContract": "Individual contracts",
  "processing.result.messageGroups.runLevel": "Affects the whole run",
  "processing.result.messages": "Messages",
  "processing.result.noBookings": "This run booked nothing.",
  "processing.result.open": "open",
  "processing.result.phase": "Phase {{phase}}",
  "processing.result.segments": "Segments",
  "processing.result.summary.contracts": "{{clean}} of {{seen}} contracts went through.",
  "processing.result.summary.runLevel": "Errors affecting the whole run: {{count}}",
  "processing.result.summary.withErrors": "{{count}} of them with an error.",
  "processing.result.superseded": "superseded",
  "processing.result.warningCount": "{{count}} warnings",
  "processing.run.configure": "Configure the run",
  "processing.run.contracts": "{{count}} contracts",
  "processing.run.covers": "Covers {{count}} employments.",
  "processing.run.coversOne": "Covers one contract.",
  "processing.run.employment": "Contract",
  "processing.run.errors.listFailed": "The runs could not be loaded.",
  "processing.run.errors.noEmployment": "This unit offers no contract to pick.",
  "processing.run.errors.noEmployments": "This unit has no employments — a run would compute nothing.",
  "processing.run.errors.periodOrder": "The end must not precede the start.",
  "processing.run.errors.startFailed": "The run could not be started.",
  "processing.run.flow.BOOKINGS.detail": "Ledger entries. Entries earlier runs wrote for the same days are reversed.",
  "processing.run.flow.BOOKINGS.title": "Bookings",
  "processing.run.flow.CALCULATION.detail": "Breaks, target and actual, day by day.",
  "processing.run.flow.CALCULATION.title": "Calculation",
  "processing.run.flow.CLOSURES.detail": "Runs every time; the rule set decides with “on run” what happens here.",
  "processing.run.flow.CLOSURES.title": "Closures",
  "processing.run.flow.CORRECTIONS.detail": "Rules amend segments; the replaced version stays readable.",
  "processing.run.flow.CORRECTIONS.title": "Corrections",
  "processing.run.flow.SEGMENTATION.detail": "Stamps and absences become time segments.",
  "processing.run.flow.SEGMENTATION.title": "Segmentation",
  "processing.run.flow.synchronous": "The run hangs off this request, not off a background service: the page waits for it to finish and then opens its protocol.",
  "processing.run.flow.title": "What a run does",
  "processing.run.from": "From",
  "processing.run.hints.recomputes": "Every day from–to is recomputed, whatever earlier runs did. Entries those runs wrote for these days are reversed.",
  "processing.run.hints.runType": "The run type only decides which “on run” rules of the rule set fire. Every day of the period is computed either way.",
  "processing.run.isolation": "Error isolation: a failing day stops neither the other contracts nor the days before it. The days that follow it in the same contract are skipped — they are computed from it.",
  "processing.run.lastRun.contracts": "{{seen}} contracts, {{clean}} without errors, {{errors}} with errors",
  "processing.run.lastRun.title": "{{name}}:",
  "processing.run.none": "This unit has no runs yet.",
  "processing.run.noUnits": "No organization units are available.",
  "processing.run.open": "View",
  "processing.run.openLog": "Open run log",
  "processing.run.outcome.FAILED": "Failed",
  "processing.run.outcome.PARTIAL": "Partly",
  "processing.run.outcome.RUNNING": "Running",
  "processing.run.outcome.SUCCEEDED": "Succeeded",
  "processing.run.preview.catchUp": ", plus {{count}} days the run catches up of its own accord",
  "processing.run.preview.catchUpDays": "+{{count}} before the period",
  "processing.run.preview.check": "Check the preview",
  "processing.run.preview.days": "{{count}} days",
  "processing.run.preview.dependentDays": "+{{count}} after it (dependent)",
  "processing.run.preview.empty": "This unit holds no contract.",
  "processing.run.preview.errors.failed": "The preview could not be loaded.",
  "processing.run.preview.inherited": "· inherited from {{unit}}",
  "processing.run.preview.locked": ", {{count}} of them sealed by a closing",
  "processing.run.preview.noDays": "no day inside the period",
  "processing.run.preview.outsideWindow": "the period lies outside this contract",
  "processing.run.preview.period": " Period: {{days}} days",
  "processing.run.preview.scheduleChanges": "the Zeitmodell changes inside the period — the rule set shown is the first day’s",
  "processing.run.preview.summary": "{{compute}} of {{total}} contracts would be computed, {{skip}} skipped.",
  "processing.run.preview.title": "What this run would touch",
  "processing.run.preview.version": "version {{version}}",
  "processing.run.recent": "Recent runs",
  "processing.run.scope": "Scope",
  "processing.run.scopes.EMPLOYMENT": "A single contract",
  "processing.run.scopes.UNIT": "The whole unit",
  "processing.run.selectHint": "Pick a run above to see its result.",
  "processing.run.start": "Start run",
  "processing.run.subtitle": "Have a period recalculated, and open an earlier run.",
  "processing.run.table.number": "Run no.",
  "processing.run.table.outcome": "Outcome",
  "processing.run.table.period": "Period",
  "processing.run.table.runType": "Type",
  "processing.run.table.scope": "Scope",
  "processing.run.table.startedAt": "Started",
  "processing.run.to": "To",
  "processing.run.type": "Run type",
  "processing.run.types.CLOSING": "Closing",
  "processing.run.types.DAILY": "Daily",
  "processing.run.types.PERIOD": "Period",
  "processing.run.types.RECALCULATION": "Recalculation",
  "processing.run.unit": "Organization unit",
  "settings.accounts.actions.create": "Create user",
  "settings.accounts.actions.edit": "Edit",
  "settings.accounts.actions.saving": "Saving…",
  "settings.accounts.columns.email": "Email",
  "settings.accounts.columns.name": "Name",
  "settings.accounts.description": "Manage user accounts and role assignments.",
  "settings.accounts.details.assignedRoles": "Assigned roles",
  "settings.accounts.details.fullName": "Full name",
  "settings.accounts.details.loading": "Loading user…",
  "settings.accounts.details.noRolesAssigned": "No roles assigned",
  "settings.accounts.details.sections.access": "Access",
  "settings.accounts.details.sections.userInfo": "User information",
  "settings.accounts.details.status": "Status",
  "settings.accounts.details.statusApproved": "Approved",
  "settings.accounts.details.statusPending": "Pending approval",
  "settings.accounts.details.userId": "User ID",
  "settings.accounts.form.createTitle": "Create user",
  "settings.accounts.form.editTitle": "Edit user",
  "settings.accounts.form.fields.email": "Email",
  "settings.accounts.form.fields.isApproved": "Approved for access",
  "settings.accounts.form.fields.isApprovedHint": "Allow this account to sign in to Workforce.",
  "settings.accounts.form.fields.name": "Full name",
  "settings.accounts.form.fields.role": "Role",
  "settings.accounts.form.fields.roleHint": "Select the role for this user.",
  "settings.accounts.form.fields.roleValue.admin": "Admin",
  "settings.accounts.form.fields.roleValue.superAdmin": "Super Admin",
  "settings.accounts.form.fields.roleValue.user": "User",
  "settings.accounts.form.loading": "Loading user…",
  "settings.accounts.form.roles.noRolesAvailable": "No roles available",
  "settings.accounts.form.roles.selected": "selected",
  "settings.accounts.form.roles.title": "Roles",
  "settings.accounts.form.validation.nameMaxLength": "Name is too long",
  "settings.accounts.form.validation.nameRequired": "Name is required",
  "settings.accounts.list.placeholderDescription": "Select a user from the table to view details in the drawer.",
  "settings.accounts.list.placeholderTitle": "User accounts",
  "settings.accounts.title": "Users",
  "settings.organizations.actions.create": "Create organization",
  "settings.organizations.actions.edit": "Edit",
  "settings.organizations.actions.saving": "Saving…",
  "settings.organizations.columns.createdAt": "Created at",
  "settings.organizations.columns.name": "Name",
  "settings.organizations.description": "Manage organizations (power user feature).",
  "settings.organizations.details.createdAt": "Created at",
  "settings.organizations.details.loading": "Loading organization…",
  "settings.organizations.details.name": "Name",
  "settings.organizations.details.organizationId": "Organization ID",
  "settings.organizations.details.sections.info": "Organization information",
  "settings.organizations.form.createTitle": "Create organization",
  "settings.organizations.form.editTitle": "Edit organization",
  "settings.organizations.form.fields.name": "Name",
  "settings.organizations.form.fields.owners": "Owners / Admins",
  "settings.organizations.form.fields.ownersEmpty": "No persons found.",
  "settings.organizations.form.fields.ownersHint": "Selected persons are added as admins of this organization (Owner position on the root unit).",
  "settings.organizations.form.fields.ownersSearch": "Search persons…",
  "settings.organizations.form.loading": "Loading organization…",
  "settings.organizations.form.validation.nameMaxLength": "Name is too long",
  "settings.organizations.form.validation.nameRequired": "Name is required",
  "settings.organizations.list.placeholderDescription": "Select an organization from the table to view details in the drawer.",
  "settings.organizations.list.placeholderTitle": "Organizations",
  "settings.organizations.title": "Organizations",
  "settings.payScales.actions.create": "Create pay scale",
  "settings.payScales.actions.edit": "Edit",
  "settings.payScales.actions.saving": "Saving…",
  "settings.payScales.columns.code": "Code",
  "settings.payScales.columns.name": "Name",
  "settings.payScales.columns.validFrom": "Valid from",
  "settings.payScales.columns.validTo": "Valid to",
  "settings.payScales.columns.weeklyWorkHours": "Weekly hours",
  "settings.payScales.description": "Manage collective agreements (pay scales) with their salary groups and levels.",
  "settings.payScales.details.code": "Code",
  "settings.payScales.details.createdAt": "Created at",
  "settings.payScales.details.dailyWorkHours": "Daily working hours",
  "settings.payScales.details.loading": "Loading pay scale…",
  "settings.payScales.details.monthlyWorkHours": "Monthly working hours",
  "settings.payScales.details.name": "Name",
  "settings.payScales.details.sections.apprenticeIncome": "Apprentice income",
  "settings.payScales.details.sections.info": "Pay scale information",
  "settings.payScales.details.sections.salaryTables": "Minimum salary tables",
  "settings.payScales.details.table.amount": "Amount",
  "settings.payScales.details.table.emptyCell": "—",
  "settings.payScales.details.table.level": "Level",
  "settings.payScales.details.tablesEmpty": "No pay grades or levels configured for this pay scale yet.",
  "settings.payScales.details.tablesLoading": "Loading salary tables…",
  "settings.payScales.details.validFrom": "Valid from",
  "settings.payScales.details.validTo": "Valid to",
  "settings.payScales.details.weeklyWorkHours": "Weekly working hours",
  "settings.payScales.form.createTitle": "Create pay scale",
  "settings.payScales.form.editTitle": "Edit pay scale",
  "settings.payScales.form.fields.code": "Code",
  "settings.payScales.form.fields.dailyWorkHours": "Daily working hours",
  "settings.payScales.form.fields.monthlyWorkHours": "Monthly working hours",
  "settings.payScales.form.fields.name": "Name",
  "settings.payScales.form.fields.validFrom": "Valid from",
  "settings.payScales.form.fields.validTo": "Valid to",
  "settings.payScales.form.fields.weeklyWorkHours": "Weekly working hours",
  "settings.payScales.form.loading": "Loading pay scale…",
  "settings.payScales.form.validation.codeMaxLength": "Code is too long",
  "settings.payScales.form.validation.codeRequired": "Code is required",
  "settings.payScales.form.validation.nameMaxLength": "Name is too long",
  "settings.payScales.form.validation.nameRequired": "Name is required",
  "settings.payScales.form.validation.validFromRequired": "Valid from is required",
  "settings.payScales.list.placeholderDescription": "Select a pay scale from the table to view details in the drawer.",
  "settings.payScales.list.placeholderTitle": "Pay scales",
  "settings.payScales.title": "Pay scales",
  "settings.profile.fields.company": "Company",
  "settings.profile.fields.createdAt": "Created at",
  "settings.profile.fields.email": "Email",
  "settings.profile.fields.personId": "Person ID",
  "settings.profile.fields.phone": "Phone",
  "settings.profile.fields.type": "Type",
  "settings.profile.loading": "Loading profile…",
  "settings.profile.noOrganization.description": "Select an organization in the context switcher to view your profile in that organization.",
  "settings.profile.noOrganization.title": "No organization selected",
  "settings.profile.noPerson.description": "No person is linked to your user account in this organization.",
  "settings.profile.noPerson.title": "No person in this organization",
  "settings.profile.sections.contact": "Contact",
  "settings.profile.sections.meta": "Metadata",
  "settings.profile.title": "Profile",
  "settings.roles.actions.cancel": "Cancel",
  "settings.roles.actions.create": "Create",
  "settings.roles.actions.edit": "Edit",
  "settings.roles.actions.save": "Save",
  "settings.roles.actions.saving": "Saving…",
  "settings.roles.columns.description": "Description",
  "settings.roles.columns.name": "Name",
  "settings.roles.description": "Manage organization roles and permissions",
  "settings.roles.form.createTitle": "Create role",
  "settings.roles.form.editTitle": "Edit role",
  "settings.roles.form.fields.description": "Description",
  "settings.roles.form.fields.name": "Name",
  "settings.roles.form.loading": "Loading role…",
  "settings.roles.form.section.info": "Role information",
  "settings.roles.form.validation.descriptionMaxLength": "Description is too long",
  "settings.roles.form.validation.nameMaxLength": "Name is too long",
  "settings.roles.form.validation.nameRequired": "Name is required",
  "settings.roles.list.placeholderDescription": "Select a role from the table to view details in the drawer.",
  "settings.roles.list.placeholderTitle": "Roles",
  "settings.roles.permissionMatrix": "Permission Matrix",
  "settings.roles.permissionMatrixDescription": "View the permissions granted to this role across different scopes and entities",
  "settings.roles.title": "Roles",
  "settings.textCatalog.actions.backToCatalog": "Back to catalog entries",
  "settings.textCatalog.actions.create": "Create entry",
  "settings.textCatalog.actions.edit": "Edit",
  "settings.textCatalog.actions.manageLanguages": "Manage languages",
  "settings.textCatalog.actions.manageTypes": "Manage catalog types",
  "settings.textCatalog.actions.saving": "Saving…",
  "settings.textCatalog.columns.catalogKey": "Key",
  "settings.textCatalog.columns.catalogType": "Type",
  "settings.textCatalog.columns.name": "Label",
  "settings.textCatalog.columns.scope": "Scope",
  "settings.textCatalog.description": "Manage dynamic catalog entries and their translations.",
  "settings.textCatalog.details.loading": "Loading catalog entry…",
  "settings.textCatalog.details.sections.info": "Entry details",
  "settings.textCatalog.filters.catalogType": "Catalog type",
  "settings.textCatalog.filters.catalogTypePlaceholder": "GENDER",
  "settings.textCatalog.form.createTitle": "Create catalog entry",
  "settings.textCatalog.form.editTitle": "Edit catalog entry",
  "settings.textCatalog.form.fields.catalogKey": "Key",
  "settings.textCatalog.form.fields.catalogKeyPlaceholder": "female",
  "settings.textCatalog.form.fields.catalogType": "Type",
  "settings.textCatalog.form.fields.catalogTypePlaceholder": "GENDER",
  "settings.textCatalog.form.fields.countryCode": "Country",
  "settings.textCatalog.form.fields.countryCodePlaceholder": "Select country",
  "settings.textCatalog.form.fields.noActiveLanguages": "No active languages configured.",
  "settings.textCatalog.form.fields.organization": "Organization",
  "settings.textCatalog.form.fields.organizationPlaceholder": "Select organization",
  "settings.textCatalog.form.fields.organizationUnit": "Organization unit",
  "settings.textCatalog.form.fields.organizationUnitPlaceholder": "Select organization unit",
  "settings.textCatalog.form.fields.scope": "Scope",
  "settings.textCatalog.form.fields.scopePlaceholder": "Select scope",
  "settings.textCatalog.form.fields.translationPlaceholder": "Translation for {{language}}",
  "settings.textCatalog.form.fields.translations": "Translations",
  "settings.textCatalog.form.loading": "Loading catalog entry…",
  "settings.textCatalog.form.scope.country": "Country",
  "settings.textCatalog.form.scope.global": "Global",
  "settings.textCatalog.form.scope.organizationUnit": "Organization unit",
  "settings.textCatalog.form.section.identity": "Identity",
  "settings.textCatalog.form.section.scope": "Scope",
  "settings.textCatalog.form.validation.catalogKeyMaxLength": "Key is too long",
  "settings.textCatalog.form.validation.catalogKeyPattern": "Key may only contain letters, numbers, underscores, and dashes",
  "settings.textCatalog.form.validation.catalogKeyRequired": "Key is required",
  "settings.textCatalog.form.validation.catalogTypeMaxLength": "Type is too long",
  "settings.textCatalog.form.validation.catalogTypePattern": "Type must be uppercase letters, numbers, and underscores",
  "settings.textCatalog.form.validation.catalogTypeRequired": "Type is required",
  "settings.textCatalog.form.validation.scopeRequired": "Scope is required",
  "settings.textCatalog.languages.actions.create": "Create language",
  "settings.textCatalog.languages.actions.edit": "Edit",
  "settings.textCatalog.languages.actions.saving": "Saving…",
  "settings.textCatalog.languages.columns.code": "Code",
  "settings.textCatalog.languages.columns.isActive": "Active",
  "settings.textCatalog.languages.columns.name": "Name",
  "settings.textCatalog.languages.columns.sortOrder": "Sort order",
  "settings.textCatalog.languages.description": "Manage available languages for catalog translations.",
  "settings.textCatalog.languages.details.loading": "Loading language…",
  "settings.textCatalog.languages.details.sections.info": "Language details",
  "settings.textCatalog.languages.form.createTitle": "Create language",
  "settings.textCatalog.languages.form.editTitle": "Edit language",
  "settings.textCatalog.languages.form.fields.code": "Code",
  "settings.textCatalog.languages.form.fields.codePlaceholder": "en",
  "settings.textCatalog.languages.form.fields.isActive": "Active",
  "settings.textCatalog.languages.form.fields.name": "Name",
  "settings.textCatalog.languages.form.fields.namePlaceholder": "English",
  "settings.textCatalog.languages.form.fields.sortOrder": "Sort order",
  "settings.textCatalog.languages.form.loading": "Loading language…",
  "settings.textCatalog.languages.form.section.info": "Language",
  "settings.textCatalog.languages.form.validation.codeMaxLength": "Code is too long",
  "settings.textCatalog.languages.form.validation.codeMinLength": "Code must be at least 2 characters",
  "settings.textCatalog.languages.form.validation.codePattern": "Code may only contain letters, numbers, underscores, and dashes",
  "settings.textCatalog.languages.form.validation.codeRequired": "Code is required",
  "settings.textCatalog.languages.form.validation.nameMaxLength": "Name is too long",
  "settings.textCatalog.languages.form.validation.nameRequired": "Name is required",
  "settings.textCatalog.languages.list.placeholderDescription": "Select a language from the table to view details in the drawer.",
  "settings.textCatalog.languages.list.placeholderTitle": "Languages",
  "settings.textCatalog.languages.title": "Languages",
  "settings.textCatalog.list.placeholderDescription": "Select a catalog entry from the table to view details in the drawer.",
  "settings.textCatalog.list.placeholderTitle": "Catalog entries",
  "settings.textCatalog.title": "Text catalog",
  "settings.textCatalog.types.actions.create": "Create catalog type",
  "settings.textCatalog.types.actions.edit": "Edit",
  "settings.textCatalog.types.actions.saving": "Saving…",
  "settings.textCatalog.types.columns.catalogType": "Type",
  "settings.textCatalog.types.columns.permissionAction": "Permission action",
  "settings.textCatalog.types.columns.permissionEntity": "Permission entity",
  "settings.textCatalog.types.description": "Register catalog types and configure the permission required for unit-context reads.",
  "settings.textCatalog.types.details.loading": "Loading catalog type…",
  "settings.textCatalog.types.details.sections.info": "Type details",
  "settings.textCatalog.types.form.createTitle": "Create catalog type",
  "settings.textCatalog.types.form.editTitle": "Edit catalog type",
  "settings.textCatalog.types.form.fields.catalogType": "Type code",
  "settings.textCatalog.types.form.fields.catalogTypePlaceholder": "GENDER",
  "settings.textCatalog.types.form.fields.organizations": "Organizations",
  "settings.textCatalog.types.form.fields.organizationsPlaceholder": "Select organizations",
  "settings.textCatalog.types.form.fields.permissionAction": "Permission action",
  "settings.textCatalog.types.form.fields.permissionActionPlaceholder": "Select action",
  "settings.textCatalog.types.form.fields.permissionEntity": "Permission entity",
  "settings.textCatalog.types.form.fields.permissionEntityPlaceholder": "Select entity",
  "settings.textCatalog.types.form.fields.permissionNone": "None",
  "settings.textCatalog.types.form.fields.scopeMode": "Scope",
  "settings.textCatalog.types.form.fields.scopeModePlaceholder": "Select scope",
  "settings.textCatalog.types.form.loading": "Loading catalog type…",
  "settings.textCatalog.types.form.permissionHint": "When set, callers must hold this scoped permission on the requested organization unit to read non-global entries.",
  "settings.textCatalog.types.form.section.identity": "Identity",
  "settings.textCatalog.types.form.section.organizations": "Organization access",
  "settings.textCatalog.types.form.section.permission": "Unit-context permission",
  "settings.textCatalog.types.form.validation.catalogTypeMaxLength": "Type is too long",
  "settings.textCatalog.types.form.validation.catalogTypePattern": "Type must be uppercase letters, numbers, and underscores",
  "settings.textCatalog.types.form.validation.catalogTypeRequired": "Type is required",
  "settings.textCatalog.types.form.validation.scopeModeRequired": "Scope is required",
  "settings.textCatalog.types.list.placeholderDescription": "Select a catalog type from the table to view details in the drawer.",
  "settings.textCatalog.types.list.placeholderTitle": "Catalog types",
  "settings.textCatalog.types.scopeMode.global": "Global",
  "settings.textCatalog.types.scopeMode.organization": "Organization",
  "settings.textCatalog.types.title": "Catalog types",
  "settings.textCatalog.values.no": "No",
  "settings.textCatalog.values.yes": "Yes",
  "skill.entity.group.persons": "Persons",
  "skill.entity.skill": "Skills",
  "skills.actions.create": "+ Skill",
  "skills.actions.edit": "Edit",
  "skills.actions.saving": "Saving …",
  "skills.columns.code": "Code",
  "skills.columns.description": "Description",
  "skills.columns.name": "Name",
  "skills.description": "This organization’s skills. How good somebody is at one is set on the person.",
  "skills.details.code": "Code",
  "skills.details.description": "Description",
  "skills.details.name": "Name",
  "skills.details.sections.info": "Skill",
  "skills.form.createTitle": "New skill",
  "skills.form.editTitle": "Edit skill",
  "skills.form.fields.code": "Code",
  "skills.form.fields.codeHint": "Short and unique. Requirements and imports refer to it later.",
  "skills.form.fields.codePlaceholder": "e.g. FORKLIFT",
  "skills.form.fields.description": "Description (optional)",
  "skills.form.fields.name": "Name",
  "skills.form.fields.namePlaceholder": "e.g. Forklift licence",
  "skills.form.loading": "Loading …",
  "skills.form.validation.codeMaxLength": "The code may be at most 50 characters.",
  "skills.form.validation.codeRequired": "Please give a code.",
  "skills.form.validation.descriptionMaxLength": "The description may be at most 1000 characters.",
  "skills.form.validation.nameMaxLength": "The name may be at most 255 characters.",
  "skills.form.validation.nameRequired": "Please give a name.",
  "skills.level.ASSISTED": "Under supervision",
  "skills.level.EXPERIENCED": "Experienced",
  "skills.level.INDEPENDENT": "Works alone",
  "skills.level.INSTRUCTOR": "Can train others",
  "skills.level.LEARNING": "Being trained",
  "skills.list.placeholderDescription": "Click a row to see the skill.",
  "skills.list.placeholderTitle": "No skill selected",
  "skills.person.add.level": "Level",
  "skills.person.add.skill": "Skill",
  "skills.person.add.skillPlaceholder": "Choose a skill",
  "skills.person.add.submit": "Add",
  "skills.person.catalogueError": "The skill catalogue could not be loaded.",
  "skills.person.description": "What this person can do, and how well. The skills themselves are maintained under Persons → Skills.",
  "skills.person.empty": "No skill has been recorded for this person yet.",
  "skills.person.loadError": "This person’s skills could not be loaded.",
  "skills.person.loading": "Loading …",
  "skills.person.noOrganization": "This person does not belong to an organization. Skills are maintained per organization.",
  "skills.person.nothingLeft": "Every skill in the catalogue has already been recorded.",
  "skills.person.remove.confirm": "“{{name}}” will be removed from this person. The skill itself stays in the catalogue.",
  "skills.person.title": "Skills",
  "skills.requirements.add.hint": "Choosing requires it straight away at “{{level}}”. Change the level afterwards in its row.",
  "skills.requirements.add.skill": "Require a skill",
  "skills.requirements.add.skillPlaceholder": "Choose a skill",
  "skills.requirements.atLeast": "at least",
  "skills.requirements.catalogueError": "The skill catalogue could not be loaded.",
  "skills.requirements.empty": "No skill is required yet.",
  "skills.requirements.loadError": "The required skills could not be loaded.",
  "skills.requirements.loading": "Loading …",
  "skills.requirements.nothingLeft": "Every skill in the catalogue is already required.",
  "skills.requirements.positionDescription": "What this position requires. The level is a minimum — anybody above it qualifies too.",
  "skills.requirements.remove.confirm": "“{{name}}” will no longer be required here. The skill itself stays in the catalogue.",
  "skills.requirements.stationDescription": "What this station requires. The level is a minimum — anybody above it qualifies too.",
  "skills.requirements.title": "Required skills",
  "skills.title": "Skills",
  "table.columns.save": "Save",
  "table.columns.showAll": "Show all",
  "table.columns.title": "Columns",
  "textCatalog.select.empty": "No catalog entries available",
  "textCatalog.select.error": "Failed to load catalog entries",
  "textCatalog.select.loading": "Loading catalog entries…",
  "timeAccounts.employment": "Employment",
  "timeAccounts.errors.loadFailed": "The balances could not be loaded.",
  "timeAccounts.fromEntries": "from {{count}} entries",
  "timeAccounts.grid.allTimeTypes": "All time types",
  "timeAccounts.grid.break": "Break",
  "timeAccounts.grid.columns": "Columns",
  "timeAccounts.grid.date": "Date",
  "timeAccounts.grid.dayCount": "{{shown}} of {{total}} days",
  "timeAccounts.grid.deduction": "Deduction",
  "timeAccounts.grid.filters.all": "All days",
  "timeAccounts.grid.filters.booked": "Only days with bookings",
  "timeAccounts.grid.filters.deviating": "Only days off plan",
  "timeAccounts.grid.kind": "Time type",
  "timeAccounts.grid.loadFailed": "The month journal could not be loaded.",
  "timeAccounts.grid.note": "Remark",
  "timeAccounts.grid.overtime": "Overtime",
  "timeAccounts.grid.show": "Show",
  "timeAccounts.grid.spans": "Calculated bookings",
  "timeAccounts.grid.target": "Target",
  "timeAccounts.grid.timeType": "Time type",
  "timeAccounts.grid.timeTypes": "Time types",
  "timeAccounts.grid.toggleDay": "Expand or collapse the day",
  "timeAccounts.grid.weekday": "Day",
  "timeAccounts.grid.worked": "Worked",
  "timeAccounts.header.nextMonth": "Next month",
  "timeAccounts.header.nextYear": "Next year",
  "timeAccounts.header.noPerson": "No employment selected",
  "timeAccounts.header.period": "Period",
  "timeAccounts.header.personnelNumber": "Staff no. {{number}}",
  "timeAccounts.header.previousMonth": "Previous month",
  "timeAccounts.header.previousYear": "Previous year",
  "timeAccounts.header.workSchedule": "Work schedule",
  "timeAccounts.ledgerHint": "Summed from the ledger up to the end of the month, not read from a stored snapshot.",
  "timeAccounts.noBalances": "Nothing was booked for this employment up to the end of the month.",
  "timeAccounts.noEmployments": "This unit has no employments.",
  "timeAccounts.organizationUnit": "Organization unit",
  "timeAccounts.summary.account": "Account",
  "timeAccounts.summary.amount": "Amount",
  "timeAccounts.summary.balance": "Balance",
  "timeAccounts.summary.balanceAfter": "Balance after",
  "timeAccounts.summary.balances": "Account balances at the end of the month",
  "timeAccounts.summary.corrections": "Special bookings and corrections",
  "timeAccounts.summary.correctionsHint": "Everything that is not the day’s own valuation — booked by hand, written by a closing, or reversed.",
  "timeAccounts.summary.monthChange": "Change this month",
  "timeAccounts.summary.noCorrections": "Nothing was booked by hand this month.",
  "timeAccounts.summary.origin": "Origin",
  "timeAccounts.summary.origins.CLOSING": "Closing",
  "timeAccounts.summary.origins.INITIALIZE": "Set to a value",
  "timeAccounts.summary.origins.MANUAL": "By hand",
  "timeAccounts.summary.showHiddenAccounts": "Also show hidden accounts ({{count}})",
  "timeAccounts.summary.unit": "Unit",
  "timeAccounts.unit.counter": "",
  "timeAccounts.unit.days": "days",
  "timeAccounts.unit.minutes": "h",
  "timeAccounts.unit.number": "",
  "timeManagement.accounts.actions.create": "Create account",
  "timeManagement.accounts.delete.confirm": "Do you really want to delete this account?",
  "timeManagement.accounts.displayFormat.DAYS": "Days",
  "timeManagement.accounts.displayFormat.DECIMAL_HOURS": "Decimal hours",
  "timeManagement.accounts.displayFormat.HH_MM": "Hours:minutes",
  "timeManagement.accounts.errors.loadFailed": "Accounts could not be loaded.",
  "timeManagement.accounts.form.createTitle": "New account",
  "timeManagement.accounts.form.editTitle": "Edit account",
  "timeManagement.accounts.form.fields.accountKind": "Account kind",
  "timeManagement.accounts.form.fields.allowsManualBooking": "Manual booking allowed",
  "timeManagement.accounts.form.fields.allowsNegativeBalance": "Negative balance allowed",
  "timeManagement.accounts.form.fields.code": "Code",
  "timeManagement.accounts.form.fields.codePlaceholder": "e.g. OVERTIME_50",
  "timeManagement.accounts.form.fields.displayFormat": "Display format",
  "timeManagement.accounts.form.fields.displayFormatHelp": "Presentation only — it does not change how the balance is stored.",
  "timeManagement.accounts.form.fields.displayFormatNone": "No format",
  "timeManagement.accounts.form.fields.internal": "Internal",
  "timeManagement.accounts.form.fields.name": "Name",
  "timeManagement.accounts.form.fields.negativeLimit": "Lower limit (optional)",
  "timeManagement.accounts.form.fields.shownInSpecialBookings": "Show under “Special bookings”",
  "timeManagement.accounts.form.fields.valueType": "Value type",
  "timeManagement.accounts.form.hints.internal": "Only visible to users with the permission “See internal accounts”.",
  "timeManagement.accounts.form.overrideTitle": "Override account",
  "timeManagement.accounts.form.validation.codeMaxLength": "Code is too long.",
  "timeManagement.accounts.form.validation.codeRequired": "Code is required.",
  "timeManagement.accounts.form.validation.nameMaxLength": "Name is too long.",
  "timeManagement.accounts.form.validation.nameRequired": "Name is required.",
  "timeManagement.accounts.form.validation.validFromRequired": "Valid from is required.",
  "timeManagement.accounts.kind.COUNTER": "Counter",
  "timeManagement.accounts.kind.ENTITLEMENT": "Entitlement",
  "timeManagement.accounts.kind.TIME": "Time account",
  "timeManagement.accounts.list.empty": "No accounts yet.",
  "timeManagement.accounts.list.hiddenFromSpecialBookings": "not under special bookings",
  "timeManagement.accounts.list.internal": "internal",
  "timeManagement.accounts.list.manualBooking": "manual booking",
  "timeManagement.accounts.list.noNegative": "no negative balance",
  "timeManagement.accounts.valueType.COUNTER": "Counter",
  "timeManagement.accounts.valueType.DAYS": "Days",
  "timeManagement.accounts.valueType.MINUTES": "Minutes",
  "timeManagement.accounts.valueType.NUMBER": "Number",
  "timeManagement.bookingTypes.actions.create": "Create booking type",
  "timeManagement.bookingTypes.delete.confirm": "Do you really want to delete this booking type?",
  "timeManagement.bookingTypes.directionHint.END": "End",
  "timeManagement.bookingTypes.directionHint.NEUTRAL": "Neutral",
  "timeManagement.bookingTypes.directionHint.START": "Start",
  "timeManagement.bookingTypes.errors.loadFailed": "Booking types could not be loaded.",
  "timeManagement.bookingTypes.form.createTitle": "New booking type",
  "timeManagement.bookingTypes.form.editTitle": "Edit booking type",
  "timeManagement.bookingTypes.form.fields.code": "Code",
  "timeManagement.bookingTypes.form.fields.codePlaceholder": "e.g. COME",
  "timeManagement.bookingTypes.form.fields.directionHint": "Direction (UI hint)",
  "timeManagement.bookingTypes.form.fields.directionHintHelp": "Only a display hint — the actual start/end pairing is decided by the rule set.",
  "timeManagement.bookingTypes.form.fields.directionHintNone": "No hint",
  "timeManagement.bookingTypes.form.fields.isRealBooking": "Real booking (not a system marker)",
  "timeManagement.bookingTypes.form.fields.name": "Name",
  "timeManagement.bookingTypes.form.overrideTitle": "Override booking type",
  "timeManagement.bookingTypes.form.validation.codeMaxLength": "Code is too long.",
  "timeManagement.bookingTypes.form.validation.codeRequired": "Code is required.",
  "timeManagement.bookingTypes.form.validation.nameMaxLength": "Name is too long.",
  "timeManagement.bookingTypes.form.validation.nameRequired": "Name is required.",
  "timeManagement.bookingTypes.form.validation.validFromRequired": "Valid from is required.",
  "timeManagement.bookingTypes.list.empty": "No booking types yet.",
  "timeManagement.bookingTypes.list.systemMarker": "system marker",
  "timeManagement.common.inheritedFrom": "inherited from {{unit}}",
  "timeManagement.common.overridden": "overridden",
  "timeManagement.common.override": "Override here",
  "timeManagement.common.restore": "Remove local version (inherit again)",
  "timeManagement.common.saving": "Saving …",
  "timeManagement.common.validFrom": "Valid from",
  "timeManagement.common.validTo": "Valid to",
  "timeManagement.common.validUntil": "until {{date}}",
  "timeManagement.dayPrograms.actions.create": "New day program",
  "timeManagement.dayPrograms.delete.confirm": "Delete this day program?",
  "timeManagement.dayPrograms.errors.loadFailed": "The day programs could not be loaded.",
  "timeManagement.dayPrograms.form.coreTime.add": "Add core time",
  "timeManagement.dayPrograms.form.coreTime.empty": "No core time is set for this day.",
  "timeManagement.dayPrograms.form.coreTime.endsNextDay": "ends next day",
  "timeManagement.dayPrograms.form.coreTime.from": "from",
  "timeManagement.dayPrograms.form.coreTime.hint": "The window somebody is expected to be there. Applies to every weekday that uses this day program.",
  "timeManagement.dayPrograms.form.coreTime.problem.incomplete": "Give both a start and an end for the core time.",
  "timeManagement.dayPrograms.form.coreTime.problem.notForward": "The core time must end after it begins.",
  "timeManagement.dayPrograms.form.coreTime.problem.overlap": "Two core times must not cover the same minute. One may begin exactly where the other ends.",
  "timeManagement.dayPrograms.form.coreTime.remove": "Remove core time",
  "timeManagement.dayPrograms.form.coreTime.title": "Core time",
  "timeManagement.dayPrograms.form.coreTime.to": "to",
  "timeManagement.dayPrograms.form.createTitle": "New day program",
  "timeManagement.dayPrograms.form.editTitle": "Edit day program",
  "timeManagement.dayPrograms.form.fields.code": "Code",
  "timeManagement.dayPrograms.form.fields.codePlaceholder": "NORMAL",
  "timeManagement.dayPrograms.form.fields.name": "Name",
  "timeManagement.dayPrograms.form.fields.targetMinutes": "Target minutes",
  "timeManagement.dayPrograms.form.fields.targetMinutesHint": "Leave empty to sum the intervals.",
  "timeManagement.dayPrograms.form.fields.validFrom": "Valid from",
  "timeManagement.dayPrograms.form.fields.validTo": "Valid to",
  "timeManagement.dayPrograms.form.intervals.add": "Add interval",
  "timeManagement.dayPrograms.form.intervals.chooseKind": "Please choose…",
  "timeManagement.dayPrograms.form.intervals.empty": "No intervals yet. Without them the day has no planned shape.",
  "timeManagement.dayPrograms.form.intervals.end": "To",
  "timeManagement.dayPrograms.form.intervals.endsNextDay": "Ends on the next day",
  "timeManagement.dayPrograms.form.intervals.errors.endBeforeStart": "The end is not after the start. For a night shift, tick “ends on the next day”.",
  "timeManagement.dayPrograms.form.intervals.errors.overlaps": "This interval overlaps an earlier one. Two intervals of the same day program must not cover the same minute twice — though one may end exactly where the next begins.",
  "timeManagement.dayPrograms.form.intervals.kind": "Kind",
  "timeManagement.dayPrograms.form.intervals.moveDown": "Move down",
  "timeManagement.dayPrograms.form.intervals.moveUp": "Move up",
  "timeManagement.dayPrograms.form.intervals.remove": "Remove",
  "timeManagement.dayPrograms.form.intervals.spans": "lasts {{minutes}} min",
  "timeManagement.dayPrograms.form.intervals.start": "From",
  "timeManagement.dayPrograms.form.intervals.targetMinutes": "Counts as (min)",
  "timeManagement.dayPrograms.form.intervals.title": "Intervals",
  "timeManagement.dayPrograms.form.overrideTitle": "Override day program",
  "timeManagement.dayPrograms.form.saving": "Saving…",
  "timeManagement.dayPrograms.form.validation.codeMaxLength": "The code may be at most 50 characters.",
  "timeManagement.dayPrograms.form.validation.codeRequired": "Please enter a code.",
  "timeManagement.dayPrograms.form.validation.nameMaxLength": "The name may be at most 255 characters.",
  "timeManagement.dayPrograms.form.validation.nameRequired": "Please enter a name.",
  "timeManagement.dayPrograms.form.validation.validFromRequired": "Please enter a start of validity.",
  "timeManagement.dayPrograms.list.empty": "This unit has no day programs yet.",
  "timeManagement.dayPrograms.list.target": "Target {{minutes}} min",
  "timeManagement.dayPrograms.list.targetFromIntervals": "Target from the intervals",
  "timeManagement.publicHolidays.actions.create": "Add holiday",
  "timeManagement.publicHolidays.calendar.empty": "No holiday falls on this unit in this year.",
  "timeManagement.publicHolidays.calendar.nextYear": "Next year",
  "timeManagement.publicHolidays.calendar.previousYear": "Previous year",
  "timeManagement.publicHolidays.calendar.title": "Calendar {{year}}",
  "timeManagement.publicHolidays.delete.confirm": "Really delete this holiday?",
  "timeManagement.publicHolidays.errors.loadFailed": "The holidays could not be loaded.",
  "timeManagement.publicHolidays.form.createTitle": "Add holiday",
  "timeManagement.publicHolidays.form.editTitle": "Edit holiday",
  "timeManagement.publicHolidays.form.fields.code": "Code",
  "timeManagement.publicHolidays.form.fields.countries": "Applies in these countries",
  "timeManagement.publicHolidays.form.fields.dayOfMonth": "Day",
  "timeManagement.publicHolidays.form.fields.kind": "How the date is set",
  "timeManagement.publicHolidays.form.fields.monthOfYear": "Month",
  "timeManagement.publicHolidays.form.fields.name": "Name",
  "timeManagement.publicHolidays.form.fields.offsetDays": "Days from Easter Sunday",
  "timeManagement.publicHolidays.form.fields.singleDate": "Date",
  "timeManagement.publicHolidays.form.fields.validFrom": "Valid from",
  "timeManagement.publicHolidays.form.fields.validTo": "Valid to",
  "timeManagement.publicHolidays.form.hints.countries": "Only countries the organigram contains. Half means half the target, without a position.",
  "timeManagement.publicHolidays.form.hints.noCountries": "No country is set anywhere in the organigram yet. Set one on the company or the root.",
  "timeManagement.publicHolidays.form.hints.offsetDays": "Negative runs before Easter: Good Friday −2, Easter Monday 1, Corpus Christi 60.",
  "timeManagement.publicHolidays.form.hints.singleDate": "The one date this holiday falls on. It does not come round again.",
  "timeManagement.publicHolidays.form.hints.validity": "When the holiday exists, not when it falls. Empty means open-ended.",
  "timeManagement.publicHolidays.form.overrideTitle": "Override holiday",
  "timeManagement.publicHolidays.form.validation.codeMaxLength": "The code may be at most 50 characters.",
  "timeManagement.publicHolidays.form.validation.codeRequired": "A code is required.",
  "timeManagement.publicHolidays.form.validation.countryNone": "Pick at least one country — otherwise the holiday applies nowhere.",
  "timeManagement.publicHolidays.form.validation.dateNeverOccurs": "There is no such day in any year.",
  "timeManagement.publicHolidays.form.validation.dayOutOfRange": "The day must be between 1 and 31.",
  "timeManagement.publicHolidays.form.validation.easterNeedsOffset": "A holiday computed from Easter needs an offset.",
  "timeManagement.publicHolidays.form.validation.easterTakesNoDate": "A holiday computed from Easter takes no fixed date.",
  "timeManagement.publicHolidays.form.validation.fixedNeedsDate": "A holiday on a fixed date needs both a month and a day.",
  "timeManagement.publicHolidays.form.validation.fixedTakesNoOffset": "A holiday on a fixed date takes no Easter offset.",
  "timeManagement.publicHolidays.form.validation.monthOutOfRange": "The month must be between 1 and 12.",
  "timeManagement.publicHolidays.form.validation.nameMaxLength": "The name may be at most 255 characters.",
  "timeManagement.publicHolidays.form.validation.nameRequired": "A name is required.",
  "timeManagement.publicHolidays.form.validation.offsetOutOfRange": "The offset is too large for a movable feast.",
  "timeManagement.publicHolidays.form.validation.recurringTakesNoSingleDate": "A recurring holiday takes no one-off date.",
  "timeManagement.publicHolidays.form.validation.singleDateMalformed": "That must be a real day, as YYYY-MM-DD.",
  "timeManagement.publicHolidays.form.validation.singleNeedsDate": "A one-off holiday needs its date.",
  "timeManagement.publicHolidays.form.validation.singleTakesNoRule": "A one-off holiday takes neither month and day nor an Easter offset.",
  "timeManagement.publicHolidays.form.validation.validFromRequired": "A start of validity is required.",
  "timeManagement.publicHolidays.kinds.EASTER_OFFSET": "Computed from Easter",
  "timeManagement.publicHolidays.kinds.FIXED": "Fixed date",
  "timeManagement.publicHolidays.kinds.SINGLE_DATE": "One-off",
  "timeManagement.publicHolidays.list.definitionsTitle": "Holidays",
  "timeManagement.publicHolidays.list.empty": "No holiday has been declared for this unit yet.",
  "timeManagement.publicHolidays.observances.FULL": "Whole",
  "timeManagement.publicHolidays.observances.HALF": "Half",
  "timeManagement.publicHolidays.tabs.calendar": "Calendar",
  "timeManagement.publicHolidays.tabs.list": "Holidays",
  "timeManagement.timeTypes.actions.create": "Create time type",
  "timeManagement.timeTypes.delete.confirm": "Do you really want to delete this time type?",
  "timeManagement.timeTypes.errors.loadFailed": "Time types could not be loaded.",
  "timeManagement.timeTypes.form.createTitle": "New time type",
  "timeManagement.timeTypes.form.editTitle": "Edit time type",
  "timeManagement.timeTypes.form.fields.category": "Category",
  "timeManagement.timeTypes.form.fields.categoryPlaceholder": "Please select …",
  "timeManagement.timeTypes.form.fields.code": "Code",
  "timeManagement.timeTypes.form.fields.displayOrder": "Display order (optional)",
  "timeManagement.timeTypes.form.fields.evaluationPriority": "Precedence",
  "timeManagement.timeTypes.form.fields.evaluationPriorityHint": "Higher number wins when two time types overlap on the same day. 0 means no precedence.",
  "timeManagement.timeTypes.form.fields.name": "Name",
  "timeManagement.timeTypes.form.fields.workTimeCreditMode": "Credit towards target time",
  "timeManagement.timeTypes.form.fields.workTimeCreditModeHint": "How a segment of this type counts towards the target time.",
  "timeManagement.timeTypes.form.fields.workTimeCreditModePlaceholder": "Select crediting mode",
  "timeManagement.timeTypes.form.overrideTitle": "Override time type",
  "timeManagement.timeTypes.form.validation.categoryRequired": "Category is required.",
  "timeManagement.timeTypes.form.validation.codeMaxLength": "Code is too long.",
  "timeManagement.timeTypes.form.validation.codeRequired": "Code is required.",
  "timeManagement.timeTypes.form.validation.creditModeRequired": "Crediting mode is required",
  "timeManagement.timeTypes.form.validation.nameMaxLength": "Name is too long.",
  "timeManagement.timeTypes.form.validation.nameRequired": "Name is required.",
  "timeManagement.timeTypes.form.validation.validFromRequired": "Valid from is required.",
  "timeManagement.timeTypes.list.empty": "No time types yet.",
  "timeManagement.timeTypes.list.priority": "precedence {{value}}",
  "timeManagement.workSchedules.actions.create": "New time model",
  "timeManagement.workSchedules.delete.confirm": "Delete this time model?",
  "timeManagement.workSchedules.errors.loadFailed": "The time models could not be loaded.",
  "timeManagement.workSchedules.form.coreTime.add": "+ Core time",
  "timeManagement.workSchedules.form.coreTime.endsNextDay": "ends next day",
  "timeManagement.workSchedules.form.coreTime.from": "Core time from",
  "timeManagement.workSchedules.form.coreTime.hint": "Optional per weekday: the core time the person is expected to be present.",
  "timeManagement.workSchedules.form.coreTime.problems.incomplete": "A core time needs both a start and an end.",
  "timeManagement.workSchedules.form.coreTime.problems.notForward": "A core time must end after it begins — tick \"ends next day\" for a window running past midnight.",
  "timeManagement.workSchedules.form.coreTime.problems.overlap": "Two core times of the same day overlap. One may end exactly where the next begins.",
  "timeManagement.workSchedules.form.coreTime.remove": "Remove core time",
  "timeManagement.workSchedules.form.coreTime.to": "to",
  "timeManagement.workSchedules.form.createTitle": "New time model",
  "timeManagement.workSchedules.form.editTitle": "Edit time model",
  "timeManagement.workSchedules.form.fields.code": "Code",
  "timeManagement.workSchedules.form.fields.codePlaceholder": "STANDARD",
  "timeManagement.workSchedules.form.fields.cycleWeeks": "Rotation (weeks)",
  "timeManagement.workSchedules.form.fields.cycleWeeksHint": "1 means the same week every time. More weeks give a rotating pattern.",
  "timeManagement.workSchedules.form.fields.name": "Name",
  "timeManagement.workSchedules.form.fields.validFrom": "Valid from",
  "timeManagement.workSchedules.form.fields.validTo": "Valid to",
  "timeManagement.workSchedules.form.grid.dayOff": "— day off —",
  "timeManagement.workSchedules.form.grid.dayProgramsFailed": "The day programs could not be loaded. The week pattern cannot be filled in until that succeeds.",
  "timeManagement.workSchedules.form.grid.noDayPrograms": "This unit has no day program yet, inherited ones included. Day programs are inherited downwards, not upwards: one on a unit below does not count here. Create one on this unit or an ancestor first.",
  "timeManagement.workSchedules.form.grid.title": "Week pattern",
  "timeManagement.workSchedules.form.grid.unreadableCycle": "Enter a rotation between 1 and 52 weeks to see the pattern.",
  "timeManagement.workSchedules.form.grid.week": "Week {{week}}",
  "timeManagement.workSchedules.form.overrideTitle": "Override time model",
  "timeManagement.workSchedules.form.problems.coreTime": "At least one core time is incomplete or overlapping — see the marked weekday.",
  "timeManagement.workSchedules.form.problems.cycleWeeks": "The rotation must be a whole number of weeks between 1 and 52.",
  "timeManagement.workSchedules.form.problems.noDays": "Assign a day program to at least one weekday, otherwise this model plans nothing.",
  "timeManagement.workSchedules.form.saving": "Saving…",
  "timeManagement.workSchedules.form.validation.codeMaxLength": "The code may be at most 50 characters.",
  "timeManagement.workSchedules.form.validation.codeRequired": "Please enter a code.",
  "timeManagement.workSchedules.form.validation.nameMaxLength": "The name may be at most 255 characters.",
  "timeManagement.workSchedules.form.validation.nameRequired": "Please enter a name.",
  "timeManagement.workSchedules.form.validation.validFromRequired": "Please enter a start of validity.",
  "timeManagement.workSchedules.list.cycle": "Rotation of {{weeks}} week(s)",
  "timeManagement.workSchedules.list.empty": "This unit has no time models yet.",
  "timeManagement.workSchedules.weekday.1": "Monday",
  "timeManagement.workSchedules.weekday.2": "Tuesday",
  "timeManagement.workSchedules.weekday.3": "Wednesday",
  "timeManagement.workSchedules.weekday.4": "Thursday",
  "timeManagement.workSchedules.weekday.5": "Friday",
  "timeManagement.workSchedules.weekday.6": "Saturday",
  "timeManagement.workSchedules.weekday.7": "Sunday",
  "timeTracking.correct": "Correct",
  "timeTracking.corrected": "corrected",
  "timeTracking.countingStamps": "{{count}} stamps counting",
  "timeTracking.employment": "Employment",
  "timeTracking.empty": "Nothing was recorded in this range.",
  "timeTracking.errors.actionFailed": "The stamp could not be saved.",
  "timeTracking.errors.loadFailed": "The stamps could not be loaded.",
  "timeTracking.errors.rangeOrder": "The end must not precede the start.",
  "timeTracking.form.abortCorrection": "Abandon correction",
  "timeTracking.form.bookingType": "Booking type",
  "timeTracking.form.chooseBookingType": "Please choose",
  "timeTracking.form.correcting": "Correcting the stamp of {{time}}",
  "timeTracking.form.date": "Date",
  "timeTracking.form.hint": "Nothing is overwritten: withdrawing sets a status, correcting writes a new stamp referring to the old one. A closed day is refused.",
  "timeTracking.form.noBookingType": "No booking type found",
  "timeTracking.form.reason": "Reason",
  "timeTracking.form.record": "Record",
  "timeTracking.form.time": "Time",
  "timeTracking.form.title": "Record a stamp",
  "timeTracking.from": "From",
  "timeTracking.isCorrection": "correction",
  "timeTracking.organizationUnit": "Organization unit",
  "timeTracking.showWithdrawn": "Show withdrawn",
  "timeTracking.to": "To",
  "timeTracking.withdraw": "Withdraw",
  "timeTracking.withdrawn": "withdrawn"
}
